(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CountUp": function() { return /* binding */ CountUp; }
/* harmony export */ });
var __assign=undefined&&undefined.__assign||function(){return(__assign=Object.assign||function(t){for(var i,n=1,s=arguments.length;n<s;n++)for(var a in i=arguments[n])Object.prototype.hasOwnProperty.call(i,a)&&(t[a]=i[a]);return t}).apply(this,arguments)},CountUp=function(){function t(t,i,n){var s=this;this.endVal=i,this.options=n,this.version="2.3.2",this.defaults={startVal:0,decimalPlaces:0,duration:2,useEasing:!0,useGrouping:!0,smartEasingThreshold:999,smartEasingAmount:333,separator:",",decimal:".",prefix:"",suffix:"",enableScrollSpy:!1,scrollSpyDelay:200,scrollSpyOnce:!1},this.finalEndVal=null,this.useEasing=!0,this.countDown=!1,this.error="",this.startVal=0,this.paused=!0,this.once=!1,this.count=function(t){s.startTime||(s.startTime=t);var i=t-s.startTime;s.remaining=s.duration-i,s.useEasing?s.countDown?s.frameVal=s.startVal-s.easingFn(i,0,s.startVal-s.endVal,s.duration):s.frameVal=s.easingFn(i,s.startVal,s.endVal-s.startVal,s.duration):s.frameVal=s.startVal+(s.endVal-s.startVal)*(i/s.duration);var n=s.countDown?s.frameVal<s.endVal:s.frameVal>s.endVal;s.frameVal=n?s.endVal:s.frameVal,s.frameVal=Number(s.frameVal.toFixed(s.options.decimalPlaces)),s.printValue(s.frameVal),i<s.duration?s.rAF=requestAnimationFrame(s.count):null!==s.finalEndVal?s.update(s.finalEndVal):s.callback&&s.callback()},this.formatNumber=function(t){var i,n,a,e,r=t<0?"-":"";i=Math.abs(t).toFixed(s.options.decimalPlaces);var o=(i+="").split(".");if(n=o[0],a=o.length>1?s.options.decimal+o[1]:"",s.options.useGrouping){e="";for(var l=0,h=n.length;l<h;++l)0!==l&&l%3==0&&(e=s.options.separator+e),e=n[h-l-1]+e;n=e}return s.options.numerals&&s.options.numerals.length&&(n=n.replace(/[0-9]/g,function(t){return s.options.numerals[+t]}),a=a.replace(/[0-9]/g,function(t){return s.options.numerals[+t]})),r+s.options.prefix+n+a+s.options.suffix},this.easeOutExpo=function(t,i,n,s){return n*(1-Math.pow(2,-10*t/s))*1024/1023+i},this.options=__assign(__assign({},this.defaults),n),this.formattingFn=this.options.formattingFn?this.options.formattingFn:this.formatNumber,this.easingFn=this.options.easingFn?this.options.easingFn:this.easeOutExpo,this.startVal=this.validateValue(this.options.startVal),this.frameVal=this.startVal,this.endVal=this.validateValue(i),this.options.decimalPlaces=Math.max(this.options.decimalPlaces),this.resetDuration(),this.options.separator=String(this.options.separator),this.useEasing=this.options.useEasing,""===this.options.separator&&(this.options.useGrouping=!1),this.el="string"==typeof t?document.getElementById(t):t,this.el?this.printValue(this.startVal):this.error="[CountUp] target is null or undefined","undefined"!=typeof window&&this.options.enableScrollSpy&&(this.error?console.error(this.error,t):(window.onScrollFns=window.onScrollFns||[],window.onScrollFns.push(function(){return s.handleScroll(s)}),window.onscroll=function(){window.onScrollFns.forEach(function(t){return t()})},this.handleScroll(this)))}return t.prototype.handleScroll=function(t){if(t&&window&&!t.once){var i=window.innerHeight+window.scrollY,n=t.el.getBoundingClientRect(),s=n.top+n.height+window.pageYOffset;s<i&&s>window.scrollY&&t.paused?(t.paused=!1,setTimeout(function(){return t.start()},t.options.scrollSpyDelay),t.options.scrollSpyOnce&&(t.once=!0)):window.scrollY>s&&!t.paused&&t.reset()}},t.prototype.determineDirectionAndSmartEasing=function(){var t=this.finalEndVal?this.finalEndVal:this.endVal;this.countDown=this.startVal>t;var i=t-this.startVal;if(Math.abs(i)>this.options.smartEasingThreshold&&this.options.useEasing){this.finalEndVal=t;var n=this.countDown?1:-1;this.endVal=t+n*this.options.smartEasingAmount,this.duration=this.duration/2}else this.endVal=t,this.finalEndVal=null;null!==this.finalEndVal?this.useEasing=!1:this.useEasing=this.options.useEasing},t.prototype.start=function(t){this.error||(this.callback=t,this.duration>0?(this.determineDirectionAndSmartEasing(),this.paused=!1,this.rAF=requestAnimationFrame(this.count)):this.printValue(this.endVal))},t.prototype.pauseResume=function(){this.paused?(this.startTime=null,this.duration=this.remaining,this.startVal=this.frameVal,this.determineDirectionAndSmartEasing(),this.rAF=requestAnimationFrame(this.count)):cancelAnimationFrame(this.rAF),this.paused=!this.paused},t.prototype.reset=function(){cancelAnimationFrame(this.rAF),this.paused=!0,this.resetDuration(),this.startVal=this.validateValue(this.options.startVal),this.frameVal=this.startVal,this.printValue(this.startVal)},t.prototype.update=function(t){cancelAnimationFrame(this.rAF),this.startTime=null,this.endVal=this.validateValue(t),this.endVal!==this.frameVal&&(this.startVal=this.frameVal,null==this.finalEndVal&&this.resetDuration(),this.finalEndVal=null,this.determineDirectionAndSmartEasing(),this.rAF=requestAnimationFrame(this.count))},t.prototype.printValue=function(t){var i=this.formattingFn(t);"INPUT"===this.el.tagName?this.el.value=i:"text"===this.el.tagName||"tspan"===this.el.tagName?this.el.textContent=i:this.el.innerHTML=i},t.prototype.ensureNumber=function(t){return"number"==typeof t&&!isNaN(t)},t.prototype.validateValue=function(t){var i=Number(t);return this.ensureNumber(i)?i:(this.error="[CountUp] invalid start or end value: ".concat(t),null)},t.prototype.resetDuration=function(){this.startTime=null,this.duration=1e3*Number(this.options.duration),this.remaining=this.duration},t}();

/***/ }),

/***/ 9208:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(9085);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_Card; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./components/common/Card/Card.styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n  margin-bottom: ",
        ";\n  padding: ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b67df60f-0"
})(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.functional.white;
}, (param)=>{
    let { theme  } = param;
    return theme.borderRadius.main;
}, (param)=>{
    let { theme  } = param;
    return theme.boxShadow.blue;
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.xl;
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.xl;
});

;// CONCATENATED MODULE: ./components/common/Card/index.tsx



const Card = (param)=>{
    let { children , className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        className: className,
        children: children
    });
};
/* harmony default export */ var common_Card = (Card);


/***/ }),

/***/ 1322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rf": function() { return /* binding */ naturalNumber; },
/* harmony export */   "mu": function() { return /* binding */ formatLongNumber; }
/* harmony export */ });
/* unused harmony export printVaultType */
function naturalNumber(value) {
    let dec = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    let num = typeof value === "string" ? Number.parseFloat(value) : value;
    const fixedFloat = num.toFixed(dec);
    return fixedFloat.toString().replace(RegExp("\\B(?<!\\.\\d*)(?=(\\d{3})+(?!\\d))", "g"), ",");
}
function round(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
}
/*
123.45 => 123.4
1,234.56 => 1.2k
12,345.67 => 12.3k
123,456.78 => 123.4k
anything over 999,999 => 1m+
*/ function formatLongNumber(longNum) {
    let num = typeof longNum === "string" ? Number.parseFloat(longNum) : longNum;
    let value = "";
    if (num > 1000000) {
        value = round(num / 1000000, 1).toString() + "m";
    } else if (num > 999) {
        value = round(num / 1000, 1).toString() + "k";
    } else {
        value = num.toFixed(1).toString();
    }
    return value;
}
function printVaultType(vaultId) {
    switch(vaultId){
        case 1:
            return "OUSD";
        case 99:
            return "test";
        default:
            return "Unknown";
    }
}


/***/ }),

/***/ 9085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./components/common/Link/index.tsx + 1 modules
var Link = __webpack_require__(157);
;// CONCATENATED MODULE: ./components/containers/home/Hero.styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 24px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 105px;\n  margin-bottom: 95px;\n  display: flex;\n  position: relative;\n  @media (max-width: ",
        ") {\n    padding-top: 60px;\n    margin-bottom: 60px;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 455px;\n  h1 {\n    padding-bottom: 8px;\n  }\n  h4 {\n    font-weight: 400;\n    font-family: ",
        ";\n    padding-bottom: 58px;\n  }\n  @media (max-width: ",
        ") {\n    h3 {\n      padding-bottom: 32px;\n    }\n  }\n  b {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 794px;\n  svg {\n    aspect-ratio: 2.29;\n    width: 100%;\n  }\n  @media (max-width: ",
        ") {\n    position: absolute;\n    width: 384px;\n    right: 0;\n    bottom: 0;\n  }\n  @media (max-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}


const HeroLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-84a847f1-0"
})(_templateObject());
const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-84a847f1-1"
})(_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
});
const Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-84a847f1-2"
})(_templateObject2(), (param)=>{
    let { theme  } = param;
    return theme.fonts.archivo;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.primary.main;
});
const HeroImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-84a847f1-3"
})(_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.md;
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./public/home/hero.svg
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgHero = function SvgHero(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 794 347",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M699.933 82.726c-4.039 26.24 5.327 46.605 22.444 46.576 18.958-.03 37.482-28.621 39.106-57.012 1.538-27.137-13.046-40.203-28.929-35.074-15.147 4.89-29.871 27.675-32.61 45.51h-.011Z",
    fill: "#82EBCD",
    stroke: "#4EBA9B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M706.414 83.757c-3.706 26.121 4.888 46.393 20.596 46.363 17.398-.03 34.398-28.49 35.888-56.752 1.411-27.012-11.972-40.018-26.548-34.913-13.9 4.867-27.413 27.548-29.926 45.302h-.01Z",
    fill: "#fff",
    stroke: "#4EBA9B",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M751.054 74.082c-2.583-1.19-7.233-.783-13.94 2.072v-6.979l11.864-6.076v-9.517l-31.526 15.89v9.765l11.535-5.908v6.949c-7.799 4.6-12.042 9.14-13.334 11.618v9.804c2.951 1.04 8.009.188 13.334-1.904v16.763l8.127-4.134V95.732c5.843-3.549 11.824-8.436 13.94-11.856.06-5.64 0-7.752 0-9.794ZM733.051 93.64c-6.826 3.291-14.854 5.542-16.841 2.855.864-3.013 6.726-8.257 12.777-12.014v6.265l8.127-4.134v-6.265c5.882-2.428 11.138-3.35 13.314-1.22-.874 3.847-11.078 11.49-17.377 14.523v-.01Z",
    fill: "#4EBA9B"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "m748.978 53.582 1.828.823-1.828.922v-1.745ZM751.054 74.082l1.818.833-1.798.852-.02-1.685ZM751.054 78.424l1.62 1.497v.674l-1.838 2.736.218-4.907ZM728.987 90.746l1.818.823v-1.755l-1.818.932ZM728.987 116.569l1.818.833v-1.765l-1.818.932ZM715.644 101.709l1.828.833v-1.051l-1.828.218ZM717.471 93.452l-1.47 2.488v1.011l1.47 1.467v-4.966ZM717.452 79.237l1.828.833v-1.765l-1.828.932Z",
    fill: "#4EBA9B"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M752.873 74.915c-2.584-1.19-7.234-.783-13.94 2.072v-6.98l11.863-6.076v-9.516l-31.526 15.89v9.765l11.535-5.908v6.948c-7.799 4.6-12.042 9.14-13.333 11.618v9.804c2.951 1.041 8.008.189 13.333-1.903v16.763l8.128-4.134V96.565c5.842-3.55 11.823-8.436 13.94-11.856.059-5.64 0-7.752 0-9.794Zm-18.004 19.558c-6.826 3.291-14.854 5.541-16.841 2.855.864-3.014 6.727-8.258 12.777-12.014v6.265l8.128-4.134V81.18c5.882-2.429 11.138-3.35 13.314-1.22-.875 3.847-11.079 11.49-17.378 14.523v-.01Z",
    fill: "#96F2D7"
  })), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M705.933 83.726c-4.039 26.24 5.327 46.605 22.444 46.576 18.958-.03 37.482-28.621 39.106-57.012 1.538-27.137-13.046-40.203-28.929-35.074-15.147 4.89-29.871 27.675-32.61 45.51h-.011Z",
    fill: "#82EBCD",
    stroke: "#4EBA9B",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
    d: "M712.414 84.757c-3.706 26.121 4.888 46.393 20.596 46.363 17.398-.03 34.398-28.49 35.888-56.752 1.411-27.012-11.972-40.018-26.548-34.913-13.9 4.867-27.413 27.548-29.926 45.302h-.01Z",
    fill: "#fff",
    stroke: "#4EBA9B",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/react.createElement("path", {
    d: "M757.054 75.082c-2.583-1.19-7.233-.783-13.94 2.072v-6.979l11.864-6.076v-9.517l-31.526 15.89v9.765l11.535-5.908v6.949c-7.799 4.6-12.042 9.14-13.334 11.618v9.804c2.951 1.04 8.009.188 13.334-1.904v16.763l8.127-4.134V96.732c5.843-3.549 11.824-8.436 13.94-11.856.06-5.64 0-7.752 0-9.794ZM739.051 94.64c-6.826 3.291-14.854 5.542-16.841 2.855.864-3.013 6.726-8.257 12.777-12.014v6.265l8.127-4.134v-6.265c5.882-2.428 11.138-3.35 13.314-1.22-.874 3.847-11.078 11.49-17.377 14.523v-.01Z",
    fill: "#4EBA9B"
  })), _path9 || (_path9 = /*#__PURE__*/react.createElement("path", {
    d: "m754.978 54.582 1.828.823-1.828.922v-1.745ZM757.054 75.082l1.818.833-1.798.852-.02-1.685ZM757.054 79.424l1.62 1.497v.674l-1.838 2.736.218-4.907ZM734.987 91.746l1.818.823v-1.755l-1.818.932ZM734.987 117.569l1.818.833v-1.765l-1.818.932ZM721.644 102.709l1.828.833v-1.051l-1.828.218ZM723.471 94.452l-1.47 2.488v1.011l1.47 1.467v-4.966ZM723.452 80.237l1.828.833v-1.765l-1.828.932Z",
    fill: "#4EBA9B"
  })), _path10 || (_path10 = /*#__PURE__*/react.createElement("path", {
    d: "M758.873 75.915c-2.584-1.19-7.234-.783-13.94 2.072v-6.98l11.863-6.076v-9.516l-31.526 15.89v9.765l11.535-5.908v6.948c-7.799 4.6-12.042 9.14-13.333 11.618v9.804c2.951 1.041 8.008.189 13.333-1.903v16.763l8.128-4.134V97.565c5.842-3.55 11.823-8.436 13.94-11.856.059-5.64 0-7.752 0-9.794Zm-18.004 19.558c-6.826 3.291-14.854 5.541-16.841 2.855.864-3.014 6.727-8.258 12.777-12.014v6.265l8.128-4.134V82.18c5.882-2.429 11.138-3.35 13.314-1.22-.875 3.847-11.079 11.49-17.378 14.523v-.01Z",
    fill: "#96F2D7"
  })), _path11 || (_path11 = /*#__PURE__*/react.createElement("path", {
    d: "M711.933 84.726c-4.039 26.24 5.327 46.605 22.444 46.576 18.958-.03 37.482-28.621 39.106-57.012 1.538-27.137-13.046-40.203-28.929-35.074-15.147 4.89-29.871 27.675-32.61 45.51h-.011Z",
    fill: "#82EBCD",
    stroke: "#4EBA9B",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/react.createElement("path", {
    d: "M718.414 85.757c-3.706 26.121 4.888 46.393 20.596 46.363 17.398-.03 34.398-28.49 35.888-56.752 1.411-27.012-11.972-40.018-26.548-34.913-13.9 4.867-27.413 27.548-29.926 45.302h-.01Z",
    fill: "#fff",
    stroke: "#4EBA9B",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/react.createElement("path", {
    d: "M763.054 76.082c-2.583-1.19-7.233-.783-13.94 2.072v-6.979l11.864-6.076v-9.517l-31.526 15.89v9.765l11.535-5.908v6.949c-7.799 4.6-12.042 9.14-13.334 11.618v9.804c2.951 1.04 8.009.188 13.334-1.904v16.763l8.127-4.134V97.732c5.843-3.549 11.824-8.436 13.94-11.856.06-5.64 0-7.752 0-9.794ZM745.051 95.64c-6.826 3.291-14.854 5.542-16.841 2.855.864-3.013 6.726-8.257 12.777-12.014v6.265l8.127-4.134v-6.265c5.882-2.428 11.138-3.35 13.314-1.22-.874 3.847-11.078 11.49-17.377 14.523v-.01Z",
    fill: "#4EBA9B"
  })), _path14 || (_path14 = /*#__PURE__*/react.createElement("path", {
    d: "m760.978 55.582 1.828.823-1.828.922v-1.745ZM763.054 76.082l1.818.833-1.798.852-.02-1.685ZM763.054 80.424l1.62 1.497v.674l-1.838 2.736.218-4.907ZM740.987 92.746l1.818.823v-1.755l-1.818.932ZM740.987 118.569l1.818.833v-1.765l-1.818.932ZM727.644 103.709l1.828.833v-1.051l-1.828.218ZM729.471 95.452l-1.47 2.488v1.011l1.47 1.467v-4.966ZM729.452 81.237l1.828.833v-1.765l-1.828.932Z",
    fill: "#4EBA9B"
  })), _path15 || (_path15 = /*#__PURE__*/react.createElement("path", {
    d: "M764.873 76.915c-2.584-1.19-7.234-.783-13.94 2.072v-6.98l11.863-6.076v-9.516l-31.526 15.89v9.765l11.535-5.908v6.948c-7.799 4.6-12.042 9.14-13.333 11.618v9.804c2.951 1.041 8.008.189 13.333-1.903v16.763l8.128-4.134V98.565c5.842-3.55 11.823-8.436 13.94-11.856.059-5.64 0-7.752 0-9.794Zm-18.004 19.558c-6.826 3.291-14.854 5.541-16.841 2.855.864-3.014 6.727-8.258 12.777-12.014v6.265l8.128-4.134V83.18c5.882-2.429 11.138-3.35 13.314-1.22-.875 3.847-11.079 11.49-17.378 14.523v-.01Z",
    fill: "#96F2D7"
  })), _path16 || (_path16 = /*#__PURE__*/react.createElement("path", {
    d: "M717.933 85.726c-4.039 26.24 5.327 46.605 22.444 46.576 18.958-.03 37.482-28.621 39.106-57.012 1.538-27.137-13.046-40.203-28.929-35.074-15.147 4.89-29.871 27.675-32.61 45.51h-.011Z",
    fill: "#82EBCD",
    stroke: "#4EBA9B",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/react.createElement("path", {
    d: "M724.414 86.757c-3.706 26.121 4.888 46.393 20.596 46.363 17.398-.03 34.398-28.49 35.888-56.752 1.411-27.012-11.972-40.018-26.548-34.913-13.9 4.867-27.413 27.548-29.926 45.302h-.01Z",
    fill: "#fff",
    stroke: "#4EBA9B",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/react.createElement("path", {
    d: "M769.054 77.082c-2.583-1.19-7.233-.783-13.94 2.072v-6.979l11.864-6.076v-9.517l-31.526 15.89v9.765l11.535-5.908v6.949c-7.799 4.6-12.042 9.14-13.334 11.618v9.804c2.951 1.04 8.009.188 13.334-1.904v16.763l8.127-4.134V98.732c5.843-3.549 11.824-8.436 13.94-11.856.06-5.64 0-7.752 0-9.794ZM751.051 96.64c-6.826 3.291-14.854 5.542-16.841 2.855.864-3.013 6.726-8.257 12.777-12.014v6.265l8.127-4.134v-6.265c5.882-2.428 11.138-3.35 13.314-1.22-.874 3.847-11.078 11.49-17.377 14.523v-.01Z",
    fill: "#4EBA9B"
  })), _path19 || (_path19 = /*#__PURE__*/react.createElement("path", {
    d: "m766.978 56.582 1.828.823-1.828.922v-1.745ZM769.054 77.082l1.818.833-1.798.852-.02-1.685ZM769.054 81.424l1.62 1.497v.674l-1.838 2.736.218-4.907ZM746.987 93.746l1.818.823v-1.755l-1.818.932ZM746.987 119.569l1.818.833v-1.765l-1.818.932ZM733.644 104.709l1.828.833v-1.051l-1.828.218ZM735.471 96.452l-1.47 2.488v1.011l1.47 1.467v-4.966ZM735.452 82.237l1.828.833v-1.765l-1.828.932Z",
    fill: "#4EBA9B"
  })), _path20 || (_path20 = /*#__PURE__*/react.createElement("path", {
    d: "M770.873 77.915c-2.584-1.19-7.234-.783-13.94 2.072v-6.98l11.863-6.076v-9.516l-31.526 15.89v9.765l11.535-5.908v6.948c-7.799 4.6-12.042 9.14-13.333 11.618v9.804c2.951 1.041 8.008.189 13.333-1.903v16.763l8.128-4.134V99.565c5.842-3.55 11.823-8.436 13.94-11.856.059-5.64 0-7.752 0-9.794Zm-18.004 19.558c-6.826 3.291-14.854 5.541-16.841 2.855.864-3.014 6.727-8.258 12.777-12.014v6.265l8.128-4.134V84.18c5.882-2.429 11.138-3.35 13.314-1.22-.875 3.847-11.079 11.49-17.378 14.523v-.01Z",
    fill: "#96F2D7"
  })), _path21 || (_path21 = /*#__PURE__*/react.createElement("path", {
    d: "M723.933 86.726c-4.039 26.24 5.327 46.605 22.444 46.576 18.958-.03 37.482-28.621 39.106-57.012 1.538-27.137-13.046-40.203-28.929-35.074-15.147 4.89-29.871 27.675-32.61 45.51h-.011Z",
    fill: "#82EBCD",
    stroke: "#4EBA9B",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/react.createElement("path", {
    d: "M730.414 87.757c-3.706 26.121 4.888 46.393 20.596 46.363 17.398-.03 34.398-28.49 35.888-56.752 1.411-27.012-11.972-40.018-26.548-34.913-13.9 4.867-27.413 27.548-29.926 45.302h-.01Z",
    fill: "#fff",
    stroke: "#4EBA9B",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/react.createElement("path", {
    d: "M775.054 78.082c-2.583-1.19-7.233-.783-13.94 2.072v-6.979l11.864-6.076v-9.517l-31.526 15.89v9.765l11.535-5.908v6.949c-7.799 4.6-12.042 9.14-13.334 11.618v9.804c2.951 1.04 8.009.188 13.334-1.904v16.763l8.127-4.134V99.732c5.843-3.549 11.824-8.436 13.94-11.856.06-5.64 0-7.752 0-9.794ZM757.051 97.64c-6.826 3.291-14.854 5.542-16.841 2.855.864-3.013 6.726-8.257 12.777-12.014v6.265l8.127-4.134v-6.265c5.882-2.428 11.138-3.35 13.314-1.22-.874 3.847-11.078 11.49-17.377 14.523v-.01Z",
    fill: "#4EBA9B"
  })), _path24 || (_path24 = /*#__PURE__*/react.createElement("path", {
    d: "m772.978 57.582 1.828.823-1.828.922v-1.745ZM775.054 78.082l1.818.833-1.798.852-.02-1.685ZM775.054 82.424l1.62 1.497v.674l-1.838 2.736.218-4.907ZM752.987 94.746l1.818.823v-1.755l-1.818.932ZM752.987 120.569l1.818.833v-1.765l-1.818.932ZM739.644 105.709l1.828.833v-1.051l-1.828.218ZM741.471 97.452l-1.47 2.488v1.011l1.47 1.467v-4.966ZM741.452 83.237l1.828.833v-1.765l-1.828.932Z",
    fill: "#4EBA9B"
  })), _path25 || (_path25 = /*#__PURE__*/react.createElement("path", {
    d: "M776.873 78.915c-2.584-1.19-7.234-.783-13.94 2.072v-6.98l11.863-6.076v-9.516l-31.526 15.89v9.765l11.535-5.908v6.948c-7.799 4.6-12.042 9.14-13.333 11.618v9.804c2.951 1.041 8.008.189 13.333-1.903v16.763l8.128-4.134v-16.693c5.842-3.55 11.823-8.436 13.94-11.856.059-5.64 0-7.752 0-9.794Zm-18.004 19.558c-6.826 3.291-14.854 5.541-16.841 2.855.864-3.014 6.727-8.258 12.777-12.014v6.265l8.128-4.134V85.18c5.882-2.429 11.138-3.35 13.314-1.22-.875 3.847-11.079 11.49-17.378 14.523v-.01Z",
    fill: "#96F2D7"
  })), _path26 || (_path26 = /*#__PURE__*/react.createElement("path", {
    d: "M729.933 87.726c-4.039 26.24 5.327 46.605 22.444 46.576 18.958-.03 37.482-28.621 39.106-57.012 1.538-27.137-13.046-40.203-28.929-35.074-15.147 4.89-29.871 27.675-32.61 45.51h-.011Z",
    fill: "#82EBCD",
    stroke: "#4EBA9B",
    strokeWidth: 2
  })), _path27 || (_path27 = /*#__PURE__*/react.createElement("path", {
    d: "M736.414 88.757c-3.706 26.121 4.888 46.393 20.596 46.363 17.398-.03 34.398-28.49 35.888-56.752 1.411-27.012-11.972-40.018-26.548-34.913-13.9 4.867-27.413 27.548-29.926 45.302h-.01Z",
    fill: "#fff",
    stroke: "#4EBA9B",
    strokeWidth: 2
  })), _path28 || (_path28 = /*#__PURE__*/react.createElement("path", {
    d: "M781.054 79.082c-2.583-1.19-7.233-.783-13.94 2.072v-6.979l11.864-6.076v-9.517l-31.526 15.89v9.765l11.535-5.908v6.949c-7.799 4.6-12.042 9.14-13.334 11.618v9.804c2.951 1.04 8.009.188 13.334-1.904v16.763l8.127-4.134v-16.693c5.843-3.549 11.824-8.436 13.94-11.856.06-5.64 0-7.752 0-9.794ZM763.051 98.64c-6.826 3.291-14.854 5.542-16.841 2.855.864-3.013 6.726-8.257 12.777-12.014v6.265l8.127-4.134v-6.265c5.882-2.428 11.138-3.35 13.314-1.22-.874 3.847-11.078 11.49-17.377 14.523v-.01Z",
    fill: "#4EBA9B"
  })), _path29 || (_path29 = /*#__PURE__*/react.createElement("path", {
    d: "m778.978 58.582 1.828.823-1.828.922v-1.745ZM781.054 79.082l1.818.833-1.798.852-.02-1.685ZM781.054 83.424l1.62 1.497v.674l-1.838 2.736.218-4.907ZM758.987 95.746l1.818.823v-1.755l-1.818.932ZM758.987 121.569l1.818.833v-1.765l-1.818.932ZM745.644 106.709l1.828.833v-1.051l-1.828.218ZM747.471 98.452l-1.47 2.488v1.011l1.47 1.467v-4.966ZM747.452 84.237l1.828.833v-1.765l-1.828.932Z",
    fill: "#4EBA9B"
  })), _path30 || (_path30 = /*#__PURE__*/react.createElement("path", {
    d: "M782.873 79.915c-2.584-1.19-7.234-.783-13.94 2.072v-6.98l11.863-6.076v-9.516l-31.526 15.89v9.765l11.535-5.908v6.948c-7.799 4.6-12.042 9.14-13.333 11.618v9.804c2.951 1.041 8.008.189 13.333-1.903v16.763l8.128-4.134v-16.693c5.842-3.55 11.823-8.436 13.94-11.856.059-5.64 0-7.752 0-9.794Zm-18.004 19.558c-6.826 3.291-14.854 5.541-16.841 2.855.864-3.014 6.727-8.258 12.777-12.014v6.265l8.128-4.134V86.18c5.882-2.429 11.138-3.35 13.314-1.22-.875 3.847-11.079 11.49-17.378 14.523v-.01Z",
    fill: "#96F2D7"
  })), _path31 || (_path31 = /*#__PURE__*/react.createElement("path", {
    d: "M417.933 177.726c-4.039 26.24 5.327 46.605 22.444 46.576 18.958-.03 37.482-28.621 39.106-57.012 1.538-27.137-13.046-40.203-28.929-35.074-15.147 4.89-29.871 27.675-32.61 45.51h-.011Z",
    fill: "#82EBCD",
    stroke: "#4EBA9B",
    strokeWidth: 2
  })), _path32 || (_path32 = /*#__PURE__*/react.createElement("path", {
    d: "M424.414 178.757c-3.706 26.121 4.888 46.393 20.596 46.363 17.398-.03 34.398-28.49 35.888-56.752 1.411-27.012-11.972-40.018-26.548-34.913-13.9 4.867-27.413 27.548-29.926 45.302h-.01Z",
    fill: "#fff",
    stroke: "#4EBA9B",
    strokeWidth: 2
  })), _path33 || (_path33 = /*#__PURE__*/react.createElement("path", {
    d: "M469.054 169.082c-2.583-1.189-7.233-.783-13.94 2.072v-6.979l11.864-6.076v-9.517l-31.526 15.891v9.764l11.535-5.908v6.949c-7.799 4.599-12.042 9.139-13.334 11.618v9.804c2.951 1.04 8.009.188 13.334-1.904v16.763l8.127-4.134v-16.693c5.843-3.549 11.824-8.436 13.94-11.856.06-5.64 0-7.752 0-9.794Zm-18.003 19.558c-6.826 3.291-14.854 5.542-16.841 2.855.864-3.013 6.726-8.257 12.777-12.014v6.265l8.127-4.134v-6.265c5.882-2.429 11.138-3.35 13.314-1.219-.874 3.846-11.078 11.489-17.377 14.522v-.01Z",
    fill: "#4EBA9B"
  })), _path34 || (_path34 = /*#__PURE__*/react.createElement("path", {
    d: "m466.978 148.582 1.828.823-1.828.922v-1.745ZM469.054 169.082l1.818.833-1.798.852-.02-1.685ZM469.054 173.424l1.62 1.497v.674l-1.838 2.736.218-4.907ZM446.987 185.746l1.818.823v-1.755l-1.818.932ZM446.987 211.569l1.818.833v-1.765l-1.818.932ZM433.644 196.709l1.828.833v-1.051l-1.828.218ZM435.471 188.452l-1.47 2.488v1.011l1.47 1.467v-4.966ZM435.452 174.237l1.828.833v-1.765l-1.828.932Z",
    fill: "#4EBA9B"
  })), _path35 || (_path35 = /*#__PURE__*/react.createElement("path", {
    d: "M470.873 169.915c-2.584-1.19-7.234-.783-13.94 2.072v-6.979l11.863-6.077v-9.516l-31.526 15.89v9.765l11.535-5.909v6.949c-7.799 4.6-12.042 9.14-13.333 11.618v9.804c2.951 1.041 8.008.189 13.333-1.903v16.763l8.128-4.134v-16.693c5.842-3.549 11.823-8.436 13.94-11.856.059-5.641 0-7.752 0-9.794Zm-18.004 19.558c-6.826 3.291-14.854 5.541-16.841 2.855.864-3.014 6.727-8.257 12.777-12.014v6.265l8.128-4.134v-6.265c5.882-2.429 11.138-3.351 13.314-1.219-.875 3.846-11.079 11.489-17.378 14.522v-.01Z",
    fill: "#96F2D7"
  })), _path36 || (_path36 = /*#__PURE__*/react.createElement("path", {
    d: "M613.864 116.135c-3.741 26.471 4.934 47.015 20.79 46.985 17.561-.03 34.721-28.872 36.225-57.513 1.424-27.375-12.085-40.555-26.797-35.381-14.713 5.173-27.67 27.917-30.208 45.909h-.01Z",
    fill: "#FFDFA0",
    stroke: "#FFBB38",
    strokeWidth: 2
  })), _path37 || (_path37 = /*#__PURE__*/react.createElement("path", {
    d: "M619.882 116.135c-3.741 26.471 4.934 47.015 20.79 46.985 17.56-.03 34.72-28.872 36.225-57.513 1.424-27.375-12.085-40.555-26.798-35.381-14.713 5.173-27.67 27.917-30.207 45.909h-.01Z",
    fill: "#fff",
    stroke: "#FFBB38",
    strokeWidth: 2
  })), _path38 || (_path38 = /*#__PURE__*/react.createElement("path", {
    d: "m669.385 96.425-3.751 1.859c-.682-2.572-1.765-4.862-3.35-6.57-4.733-5.093-9.798-2.843-14.351-.603-3.992 1.97-10.39 5.395-10.39 5.395v15.671l-4.263 2.11v5.917l4.263-2.17v6.028l-4.263 2.109v5.917l4.263-2.17v15.632s8.574-4.169 11.583-5.767c6.84-3.636 11.814-9.352 15.254-19.137.512-1.457.973-3.185 1.344-5.073l3.671-1.869v-5.394l-2.899 1.436c.151-2.14.161-4.32-.02-6.449l2.919-1.487v-5.395l-.01.01Zm-28.162 3.336s3.33-1.638 8.254-4.25c6.489-3.435 10.36-.803 12.145 4.762l-20.389 10.086V99.761h-.01Zm9.698 33.925c-3.52 2.039-9.698 4.832-9.698 4.832V128.05l20.239-10.307c-2.176 7.142-6.619 13.672-10.541 15.943Zm11.885-24.301c0 .743-.04 1.486-.111 2.24l-21.472 10.618v-6.088l21.382-10.889c.131 1.306.201 2.682.201 4.108v.011Z",
    fill: "#FFBB38"
  })), _path39 || (_path39 = /*#__PURE__*/react.createElement("path", {
    d: "m670.809 97.018-3.751 1.859c-.682-2.572-1.765-4.863-3.35-6.57-4.734-5.094-9.798-2.843-14.352-.603-3.991 1.969-10.39 5.394-10.39 5.394v15.672l-4.262 2.11v5.917l4.262-2.17v6.027l-4.262 2.11v5.917l4.262-2.17v15.631s8.575-4.169 11.584-5.766c6.84-3.637 11.814-9.353 15.254-19.137.512-1.457.973-3.185 1.344-5.073l3.671-1.869v-5.395l-2.899 1.437c.151-2.14.161-4.32-.02-6.45l2.919-1.486v-5.395l-.01.01Zm-28.162 3.335s3.33-1.637 8.254-4.25c6.489-3.435 10.36-.803 12.145 4.763l-20.389 10.086v-10.599h-.01Zm9.698 33.925c-3.52 2.04-9.698 4.832-9.698 4.832v-10.467l20.239-10.308c-2.177 7.143-6.62 13.673-10.541 15.943Zm11.885-24.301c0 .744-.041 1.487-.111 2.24l-21.472 10.619v-6.088l21.382-10.89c.13 1.306.201 2.683.201 4.109v.01Z",
    fill: "#FFDFA0"
  })), _path40 || (_path40 = /*#__PURE__*/react.createElement("path", {
    d: "m669.385 96.425 1.424.593-1.424.703v-1.296ZM669.385 108.31l1.424.602-1.424.704v-1.306ZM637.543 145.55l1.424.592v-1.285l-1.424.693ZM633.28 132.088l1.424.593v-1.316l-1.424.723ZM633.28 120.194l1.424.603v-1.326l-1.424.723Z",
    fill: "#FFBB38"
  })), _path41 || (_path41 = /*#__PURE__*/react.createElement("path", {
    d: "M619.864 117.135c-3.741 26.471 4.934 47.015 20.79 46.985 17.561-.03 34.721-28.872 36.225-57.513 1.424-27.375-12.085-40.555-26.797-35.381-14.713 5.173-27.67 27.917-30.208 45.909h-.01Z",
    fill: "#FFDFA0",
    stroke: "#FFBB38",
    strokeWidth: 2
  })), _path42 || (_path42 = /*#__PURE__*/react.createElement("path", {
    d: "M625.882 117.135c-3.741 26.471 4.934 47.015 20.79 46.985 17.56-.03 34.72-28.872 36.225-57.513 1.424-27.375-12.085-40.555-26.798-35.381-14.713 5.173-27.67 27.917-30.207 45.909h-.01Z",
    fill: "#fff",
    stroke: "#FFBB38",
    strokeWidth: 2
  })), _path43 || (_path43 = /*#__PURE__*/react.createElement("path", {
    d: "m675.385 97.425-3.751 1.859c-.682-2.572-1.765-4.862-3.35-6.57-4.733-5.093-9.798-2.843-14.351-.603-3.992 1.97-10.39 5.395-10.39 5.395v15.671l-4.263 2.11v5.917l4.263-2.17v6.028l-4.263 2.109v5.917l4.263-2.17v15.632s8.574-4.169 11.583-5.767c6.84-3.636 11.814-9.352 15.254-19.137.512-1.457.973-3.185 1.344-5.073l3.671-1.869v-5.394l-2.899 1.436c.151-2.14.161-4.32-.02-6.449l2.919-1.487v-5.395l-.01.01Zm-28.162 3.336s3.33-1.638 8.254-4.25c6.489-3.435 10.36-.803 12.145 4.762l-20.389 10.086v-10.598h-.01Zm9.698 33.925c-3.52 2.039-9.698 4.832-9.698 4.832V129.05l20.239-10.307c-2.176 7.142-6.619 13.672-10.541 15.943Zm11.885-24.301c0 .743-.04 1.486-.111 2.24l-21.472 10.618v-6.088l21.382-10.889c.131 1.306.201 2.682.201 4.108v.011Z",
    fill: "#FFBB38"
  })), _path44 || (_path44 = /*#__PURE__*/react.createElement("path", {
    d: "m676.809 98.018-3.751 1.859c-.682-2.572-1.765-4.863-3.35-6.57-4.734-5.094-9.798-2.843-14.352-.603-3.991 1.969-10.39 5.394-10.39 5.394v15.672l-4.262 2.11v5.917l4.262-2.17v6.027l-4.262 2.11v5.917l4.262-2.17v15.631s8.575-4.169 11.584-5.766c6.84-3.637 11.814-9.353 15.254-19.137.512-1.457.973-3.185 1.344-5.073l3.671-1.869v-5.395l-2.899 1.437c.151-2.14.161-4.32-.02-6.45l2.919-1.486v-5.395l-.01.01Zm-28.162 3.335s3.33-1.637 8.254-4.25c6.489-3.435 10.36-.803 12.145 4.763l-20.389 10.086v-10.599h-.01Zm9.698 33.925c-3.52 2.04-9.698 4.832-9.698 4.832v-10.467l20.239-10.308c-2.177 7.143-6.62 13.673-10.541 15.943Zm11.885-24.301c0 .744-.041 1.487-.111 2.24l-21.472 10.619v-6.088l21.382-10.89c.13 1.306.201 2.683.201 4.109v.01Z",
    fill: "#FFDFA0"
  })), _path45 || (_path45 = /*#__PURE__*/react.createElement("path", {
    d: "m675.385 97.425 1.424.593-1.424.703v-1.296ZM675.385 109.31l1.424.602-1.424.704v-1.306ZM643.543 146.55l1.424.592v-1.285l-1.424.693ZM639.28 133.088l1.424.593v-1.316l-1.424.723ZM639.28 121.194l1.424.603v-1.326l-1.424.723Z",
    fill: "#FFBB38"
  })), _path46 || (_path46 = /*#__PURE__*/react.createElement("path", {
    d: "M625.864 118.135c-3.741 26.471 4.934 47.015 20.79 46.985 17.561-.03 34.721-28.872 36.225-57.513 1.424-27.375-12.085-40.555-26.797-35.381-14.713 5.173-27.67 27.917-30.208 45.909h-.01Z",
    fill: "#FFDFA0",
    stroke: "#FFBB38",
    strokeWidth: 2
  })), _path47 || (_path47 = /*#__PURE__*/react.createElement("path", {
    d: "M631.882 118.135c-3.741 26.471 4.934 47.015 20.79 46.985 17.56-.03 34.72-28.872 36.225-57.513 1.424-27.375-12.085-40.555-26.798-35.381-14.713 5.173-27.67 27.917-30.207 45.909h-.01Z",
    fill: "#fff",
    stroke: "#FFBB38",
    strokeWidth: 2
  })), _path48 || (_path48 = /*#__PURE__*/react.createElement("path", {
    d: "m681.385 98.425-3.751 1.859c-.682-2.572-1.765-4.862-3.35-6.57-4.733-5.093-9.798-2.843-14.351-.603-3.992 1.97-10.39 5.395-10.39 5.395v15.671l-4.263 2.11v5.917l4.263-2.17v6.028l-4.263 2.109v5.917l4.263-2.17v15.632s8.574-4.169 11.583-5.767c6.84-3.636 11.814-9.352 15.254-19.137.512-1.457.973-3.185 1.344-5.073l3.671-1.869v-5.394l-2.899 1.436c.151-2.14.161-4.32-.02-6.449l2.919-1.487v-5.395l-.01.01Zm-28.162 3.336s3.33-1.638 8.254-4.25c6.489-3.435 10.36-.803 12.145 4.762l-20.389 10.086v-10.598h-.01Zm9.698 33.925c-3.52 2.039-9.698 4.832-9.698 4.832V130.05l20.239-10.307c-2.176 7.142-6.619 13.672-10.541 15.943Zm11.885-24.301c0 .743-.04 1.486-.111 2.24l-21.472 10.618v-6.088l21.382-10.889c.131 1.306.201 2.682.201 4.108v.011Z",
    fill: "#FFBB38"
  })), _path49 || (_path49 = /*#__PURE__*/react.createElement("path", {
    d: "m682.809 99.018-3.751 1.859c-.682-2.572-1.765-4.863-3.35-6.57-4.734-5.094-9.798-2.843-14.352-.603-3.991 1.969-10.39 5.394-10.39 5.394v15.672l-4.262 2.11v5.917l4.262-2.17v6.027l-4.262 2.11v5.917l4.262-2.17v15.631s8.575-4.169 11.584-5.766c6.84-3.637 11.814-9.353 15.254-19.137.512-1.457.973-3.185 1.344-5.073l3.671-1.869v-5.395l-2.899 1.437c.151-2.14.161-4.32-.02-6.45l2.919-1.486v-5.395l-.01.01Zm-28.162 3.335s3.33-1.637 8.254-4.25c6.489-3.435 10.36-.803 12.145 4.763l-20.389 10.086v-10.599h-.01Zm9.698 33.925c-3.52 2.04-9.698 4.832-9.698 4.832v-10.467l20.239-10.308c-2.177 7.143-6.62 13.673-10.541 15.943Zm11.885-24.301c0 .744-.041 1.487-.111 2.24l-21.472 10.619v-6.088l21.382-10.89c.13 1.306.201 2.683.201 4.109v.01Z",
    fill: "#FFDFA0"
  })), _path50 || (_path50 = /*#__PURE__*/react.createElement("path", {
    d: "m681.385 98.425 1.424.593-1.424.703v-1.296ZM681.385 110.31l1.424.602-1.424.704v-1.306ZM649.543 147.55l1.424.592v-1.285l-1.424.693ZM645.28 134.088l1.424.593v-1.316l-1.424.723ZM645.28 122.194l1.424.603v-1.326l-1.424.723Z",
    fill: "#FFBB38"
  })), _path51 || (_path51 = /*#__PURE__*/react.createElement("path", {
    d: "M521.864 148.135c-3.741 26.471 4.934 47.015 20.79 46.985 17.561-.03 34.721-28.872 36.225-57.513 1.424-27.375-12.085-40.555-26.797-35.381-14.713 5.173-27.67 27.917-30.208 45.909h-.01Z",
    fill: "#A3D8FF",
    stroke: "#34AAFF",
    strokeWidth: 2
  })), _path52 || (_path52 = /*#__PURE__*/react.createElement("path", {
    d: "M527.882 148.135c-3.741 26.471 4.934 47.015 20.79 46.985 17.561-.03 34.72-28.872 36.225-57.513 1.424-27.375-12.085-40.555-26.798-35.381-14.713 5.173-27.67 27.917-30.207 45.909h-.01Z",
    fill: "#fff",
    stroke: "#34AAFF",
    strokeWidth: 2
  })), _path53 || (_path53 = /*#__PURE__*/react.createElement("path", {
    d: "M561.98 116.682v2.752c0 1.135.15 1.407 1.915 1.708 4.333.754 7.512 6.018 8.615 10.85 1.174 5.113.923 12.899-.662 19.117-1.745 6.861-4.302 11.563-5.686 13.482-1.153 1.597-2.497 3.576-3.5 4.761-.532.633-.682 1.176-.682 2.281v2.25c0 .884.491 1.135 1.283.331 2.397-2.451 4.855-6.107 6.369-8.84 1.915-3.446 4.754-10.156 5.977-16.475 1.063-5.495 1.495-12.286.421-17.801-1.073-5.516-2.216-10.488-5.867-13.12-2.336-1.688-3.309-2.2-5.385-2.753-1.494-.392-2.808.02-2.808 1.467l.01-.01ZM550.497 122.026c1.434-1.527 1.755-1.447 1.755.08v2.432c0 .984-.401 1.486-1.374 2.632-1.304 1.527-2.718 3.475-4.543 6.891-1.826 3.416-3.801 8.238-4.814 15.31-1.013 7.072-.452 13.15 1.434 17.62 1.885 4.461 4.122 6.349 6.308 7.133 1.615.583 2.989.181 2.989 2.039v2.1c0 .804.07 2.3-2.186 1.919-2.458-.422-5.717-1.708-7.653-4.641-2.296-3.466-3.791-7.635-4.392-12.196-.662-4.973-.632-9.855.631-16.154 1.254-6.289 3.591-12.467 5.537-16.204 1.945-3.747 4.914-7.454 6.318-8.951l-.01-.01Z",
    fill: "#34AAFF"
  })), _path54 || (_path54 = /*#__PURE__*/react.createElement("path", {
    d: "M555.391 129.601c0-1.678.632-2.04.953-2.19.321-.151.922-.482 1.344-.693.421-.211 1.073-.181 1.073.984v4.049c.892-.332 2.216-.483 3.199.572.983 1.055 1.284 2.13 1.585 3.325.3 1.196-.211 2.16-.843 2.492-.632.331-1.193.663-1.554.783-.361.121-.692.061-.923-.844-.231-.904-.782-2.22-2.307-1.918-1.895.371-3.289 2.16-3.741 3.114-.451.954-.922 3.205-.451 4.671.401 1.236 1.645 1.366 3.139.945 2.066-.583 3.891-.945 4.874-.523.983.422 2.508 1.407 2.518 5.455.01 4.049-.923 6.801-2.036 8.509-1.114 1.708-2.307 3.114-3.33 3.717v3.687c0 .753-.261 1.949-1.003 2.371-.742.422-1.103.542-1.524.693-.422.15-.893-.091-.893-1.045v-3.988c-.983.211-2.126.361-3.019-.03-.892-.392-1.945-1.859-2.126-2.492-.18-.633-.511-2.401-.571-3.144-.061-.743.3-1.226.842-1.497.542-.271.983-.512 1.374-.693.391-.181.983-.633 1.224.814.24 1.446.812 2.752 2.366 2.571 1.555-.18 3.35-1.436 4.333-3.204.983-1.768 1.073-4.24.722-5.505-.351-1.266-1.765-1.296-3.6-.935-1.836.362-3.25 1.135-5.095.091-2.006-1.135-2.036-4.732-1.795-6.771.24-2.04 1.313-5.666 2.808-7.344 1.494-1.677 2.126-2.16 2.457-2.431v-3.596Z",
    fill: "#34AAFF"
  })), _path55 || (_path55 = /*#__PURE__*/react.createElement("path", {
    d: "M560.476 138.662c.411.864 1.524 1.045 2.096.784.572-.262-.602-1.437-.602-1.437l-1.504.653h.01ZM563.905 145.302c-1.654-1.034-2.778-1.245-3.831-1.085-1.053.161 1.535 1.809 1.535 1.809l2.306-.714-.01-.01ZM555.822 168.709c.712.472 1.505.774 1.966.603.461-.171 0-1.477 0-1.477l-1.966.874ZM562.131 174.526c.732.884 1.444.814 1.885.703.442-.11-.16-1.688-.16-1.688l-1.725.985ZM552.553 155.7c.612-.191 1.634.392 1.805.753.17.362-.532.925-.532.925l-1.153-.422-.12-1.246v-.01ZM558.119 126.627c.662-.03 1.364.251 1.795.693.432.442-1.223.924-1.223.924l-.562-1.617h-.01ZM560.476 131.54c.31.08 1.454.271 2.366.874.913.602-1.534.773-1.534.773l-.832-1.647ZM551.941 120.921c.733-.01 1.324.402 1.525.603.2.201-1.204 1.607-1.204 1.607l-.21-.924-.111-1.286ZM551.209 174.606c.883.251 1.916.643 2.106.924.191.282-1.163.242-1.163.242l-.682-.583-.261-.583Z",
    fill: "#34AAFF"
  })), _path56 || (_path56 = /*#__PURE__*/react.createElement("path", {
    d: "M563.384 117.214v2.753c0 1.135.151 1.406 1.916 1.708 4.332.753 7.511 6.017 8.615 10.849 1.173 5.113.922 12.899-.662 19.117-1.745 6.862-4.303 11.563-5.687 13.482-1.153 1.597-2.497 3.576-3.5 4.762-.532.633-.682 1.175-.682 2.28v2.25c0 .884.492 1.136 1.284.332 2.397-2.451 4.854-6.108 6.368-8.84 1.916-3.446 4.754-10.157 5.978-16.476 1.063-5.495 1.494-12.286.421-17.801-1.073-5.515-2.217-10.488-5.867-13.12-2.337-1.688-3.31-2.2-5.386-2.753-1.494-.391-2.808.021-2.808 1.467l.01-.01ZM551.901 122.559c1.434-1.527 1.755-1.447 1.755.08v2.431c0 .985-.401 1.487-1.374 2.632-1.304 1.527-2.718 3.476-4.543 6.892-1.825 3.415-3.801 8.237-4.814 15.309-1.013 7.073-.451 13.151 1.434 17.621 1.886 4.47 4.122 6.349 6.308 7.133 1.615.582 2.989.18 2.989 2.039v2.099c0 .804.07 2.301-2.186 1.919-2.457-.422-5.717-1.708-7.652-4.641-2.297-3.466-3.791-7.635-4.393-12.196-.662-4.972-.632-9.855.632-16.153 1.253-6.289 3.59-12.467 5.536-16.205 1.945-3.747 4.914-7.454 6.318-8.95l-.01-.01Z",
    fill: "#A3D8FF"
  })), _path57 || (_path57 = /*#__PURE__*/react.createElement("path", {
    d: "M556.805 130.123c0-1.678.632-2.039.953-2.19.321-.151.922-.482 1.344-.693.421-.211 1.073-.181 1.073.984v4.049c.892-.332 2.216-.482 3.199.573.983 1.054 1.284 2.129 1.585 3.325.3 1.195-.211 2.16-.843 2.491-.632.332-1.193.663-1.554.784-.361.12-.692.06-.923-.844-.231-.904-.782-2.22-2.307-1.919-1.895.372-3.289 2.16-3.741 3.114-.451.955-.922 3.205-.451 4.672.401 1.235 1.645 1.366 3.139.944 2.066-.583 3.892-.944 4.874-.522.983.421 2.508 1.406 2.518 5.454.01 4.049-.923 6.802-2.036 8.509-1.113 1.708-2.307 3.115-3.33 3.717v3.687c0 .754-.261 1.949-1.003 2.371-.742.422-1.103.542-1.524.693-.421.151-.893-.09-.893-1.045v-3.988c-.983.211-2.126.362-3.019-.03-.892-.392-1.945-1.858-2.126-2.491-.18-.633-.511-2.401-.571-3.145-.061-.743.301-1.225.842-1.497.542-.271.983-.512 1.374-.693.391-.181.983-.633 1.224.814.24 1.447.812 2.753 2.366 2.572 1.555-.181 3.35-1.437 4.333-3.205.983-1.768 1.073-4.239.722-5.505s-1.765-1.296-3.6-.934c-1.836.361-3.25 1.135-5.095.09-2.006-1.135-2.036-4.732-1.795-6.771.24-2.039 1.314-5.666 2.808-7.343 1.494-1.678 2.126-2.16 2.457-2.431v-3.597Z",
    fill: "#A3D8FF"
  })), _path58 || (_path58 = /*#__PURE__*/react.createElement("path", {
    d: "M599.69 298.02v-13.35l-17.09-1.98v-13.35l-38.03-3.35V140.33l12.06-10.37h2.68l39.25-33.86V72.9l-203-70.55-203 33.63-39.25 29.9V94.2l17.09 1.9v13.77l33.81 2.25V238.7l-50.91 40.71v4.43l-10.45 8.43v13.77l426.89 37.41 40.6-32.78v-11.75l-10.67-.91.02.01Zm-302.1-53.78-30.12-2.65-.15-123.26 30.27 2.64v123.28-.01Zm92.37 8.14-30.12-2.65V125.39l29.2 2.02.92 124.97Zm62.3 5.49-.05-123.05 30.12 2.24-.62 122.99-29.45-2.18Z",
    fill: "#fff"
  })), _path59 || (_path59 = /*#__PURE__*/react.createElement("path", {
    d: "M599.69 298.02v-13.35l-17.09-1.98v-13.35l-38.03-3.35V140.33l12.06-10.37h2.68l39.25-33.86V72.9l-203-70.55-203 33.63-39.25 29.9V94.2l17.09 1.9v13.77l33.81 2.25V238.7l-50.91 40.71v4.43l-10.45 8.43v13.77l426.89 37.41 40.6-32.78v-11.75l-10.67-.91.02.01Zm-302.1-53.78-30.12-2.65-.15-123.26 30.27 2.64v123.28-.01Zm92.37 8.14-30.12-2.65V125.39l29.2 2.02.92 124.97Zm62.3 5.49-.05-123.05 30.12 2.24-.62 122.99-29.45-2.18Z",
    fill: "url(#hero_svg__a)"
  })), _path60 || (_path60 = /*#__PURE__*/react.createElement("path", {
    d: "m339.23 88.18 33.12 2.77V57.82l-33.12-2.77v33.13Zm9.31-21.57c-1.22 1.48-1.68 3.23-1.68 4.48 0 2.73.15 7.18.19 8.61l-5.83 5.3V58.69l7.31 7.92h.01Zm-.12 14.55 14.79 1.34 5.67 6.14-26.27-2.2 5.82-5.29-.01.01Zm12.76-.85-10.75-.98 5.36-4.87 5.4 5.85h-.01Zm1.56-1.26-11.35-12.3c1.14-.69 2.59-.98 4.32-.84 6.41.52 7.11 5.69 7.11 7.89 0 1.76-.04 3.74-.07 5.25h-.01Zm-8.31-6.06L349 77.93c-.06-1.97-.14-4.86-.14-6.84 0-.8.29-1.96 1.05-2.99l4.52 4.89Zm15.92 14.31-5.66-6.14c.03-1.15.12-4.54.12-7.36 0-4.43-2.35-9.35-8.94-9.88-2.76-.22-4.63.5-5.86 1.34l-7.31-7.92 27.65 2.31V87.3Z",
    fill: "#3763FF"
  })), _path61 || (_path61 = /*#__PURE__*/react.createElement("path", {
    d: "M600.17 295.78v-13.32l-17.09-1.98V267.1l-38.03-3.35V139.4l11.64-9.94 2.43.21 39.92-34.44V70.86L395.37.08l-.24-.08-203.49 33.82-39.84 30.24v29.73l17.09 1.51v14.17l34.81 3.03v124.39l-51.52 40.41-.38.3v4.44l-10.45 8.43v15.17l428.21 37.53 41.28-33.33v-13.15l-10.67-.91Zm6.99 2.6-38.22 28.95-7.61-.67 38.13-28.95 7.69.66.01.01Zm-453.37-19.2 404 35.31v11.87l-404-35.4v-11.78Zm427.28 1.69L542.69 310v-10.84l38.38-29.14v10.85Zm-40.38 30.12-369.81-32.32v-11.72l369.81 32.61v11.43Zm-371.81-32.5-13.48-1.18 13.48-10.58v11.76Zm429.28 17.7-38.38 29.13v-10.84l38.38-29.13v10.84Zm-1.59-12.15-37.59 28.54-14.7-1.28 38.07-28.9 14.22 1.64ZM482.79 270.4c4.81 4.71 17.6 6.87 30.3 6.87s25.18-2.15 29.95-6.84v5.68c0 5.22-12.88 9.16-29.95 9.16s-30.3-3.94-30.3-9.16v-5.71Zm-92.37-9.04c4.81 4.71 17.6 6.87 30.3 6.87s25.18-2.15 29.95-6.84v5.68c0 5.22-12.88 9.16-29.95 9.16s-30.3-3.94-30.3-9.16v-5.71Zm-92.37-7.54c4.81 4.71 17.6 6.87 30.3 6.87s25.18-2.15 29.95-6.84v5.68c0 5.22-12.88 9.16-29.95 9.16s-30.3-3.94-30.3-9.16v-5.71Zm-92.37-7.22c4.81 4.71 17.59 6.87 30.3 6.87s25.18-2.15 29.95-6.84v5.68c0 5.22-12.88 9.16-29.95 9.16s-30.3-3.94-30.3-9.16v-5.71Zm17.36-119.2c.4.05.83.09 1.24.14v123.27c-3.67-.44-6.93-1.08-9.67-1.89V125.74c2.93.81 5.97 1.33 8.43 1.66Zm42.89 103.76v11.14c0 1.89-1.69 3.61-4.64 5.03V124.3c1.92-.83 3.5-1.8 4.64-2.92v109.78Zm-6.64 17.03c-2.61.98-5.89 1.77-9.67 2.34V127.3c3.57-.51 6.88-1.25 9.67-2.22v123.11Zm-11.67 2.61c-2.98.36-6.23.59-9.67.65V128.19c3.28-.06 6.55-.27 9.67-.63V250.8Zm-11.67.67c-3.41 0-6.66-.16-9.67-.45V127.76c3.09.29 6.37.44 9.67.45v123.26Zm31.98-20.31V118.08l28.12 2.45V241.8l-28.12-2.48v-8.16Zm47.48-96.54c.4.05.83.09 1.24.14v123.27c-3.67-.44-6.93-1.08-9.67-1.89V132.96c2.93.81 5.97 1.33 8.43 1.66Zm3.24.36c3.09.29 6.37.44 9.67.45v123.26c-3.41 0-6.66-.16-9.67-.45V134.98Zm11.67.43c3.28-.06 6.55-.27 9.67-.63v123.24c-2.98.36-6.23.59-9.67.65V135.41Zm11.67-.89c3.57-.51 6.88-1.25 9.67-2.22v123.11c-2.61.98-5.89 1.77-9.67 2.34V134.52Zm11.67-3c1.92-.83 3.5-1.8 4.64-2.92v120.92c0 1.89-1.69 3.6-4.64 5.03V131.52Zm-37.99 1.11c-10.87-1.44-17.62-4.65-17.62-8.37v-3.57l59.82 5.21c-3.3 6.27-25.27 8.97-42.2 6.72v.01Zm-17.62-4.04c1.65 1.61 4.17 2.83 6.93 3.75v123.13c-4.36-1.58-6.93-3.64-6.93-5.96V128.59Zm62.25 109.78V126.12l28.12 2.45v121.36l-28.12-2.48v-9.08Zm47.48-96.22c.4.05.83.09 1.24.14v123.27c-3.67-.44-6.93-1.08-9.67-1.89V140.49c2.93.81 5.97 1.33 8.43 1.66Zm3.24.36c3.09.29 6.36.44 9.67.44v123.26c-3.41 0-6.66-.16-9.67-.45V142.5v.01Zm11.67.43c3.28-.06 6.55-.27 9.67-.63v123.24c-2.98.36-6.23.59-9.67.65V142.94Zm11.67-.89c3.57-.51 6.88-1.25 9.67-2.22v123.11c-2.61.98-5.89 1.77-9.67 2.34V142.05Zm11.67-3c1.92-.83 3.5-1.8 4.64-2.92v120.92c0 1.89-1.69 3.6-4.64 5.03V139.05Zm-37.99 1.11c-10.87-1.44-17.62-4.65-17.62-8.37v-3.06l59.53 5.19c-4.15 5.93-25.43 8.42-41.91 6.24Zm-17.62-4.04c1.65 1.61 4.17 2.83 6.93 3.75V263c-4.36-1.58-6.93-3.64-6.93-5.96V136.12Zm62.25 109.78V134.16l28.12 2.45v121.45l-28.12-2.48v-9.68Zm88.93-103.99.42.04.92-.79-.04.64c-2.01 6.76-24.96 9.72-42.49 7.4-10.87-1.44-17.62-4.65-17.62-8.37v-4.04l58.81 5.12Zm-14.87 132.4V151.08c3.57-.51 6.88-1.25 9.67-2.22v123.11c-2.61.98-5.89 1.77-9.67 2.34Zm-26.58-123.13c.4.05.83.09 1.24.14v123.27c-3.67-.44-6.93-1.08-9.67-1.89V149.52c2.93.81 5.96 1.33 8.43 1.66Zm3.24.36c3.09.29 6.36.44 9.67.45v123.26c-3.41 0-6.66-.16-9.67-.45V151.54Zm11.67.43c3.28-.06 6.55-.27 9.67-.63v123.24c-2.98.36-6.23.59-9.67.65V151.97Zm-32.27-6.81c1.65 1.61 4.17 2.83 6.93 3.75v123.13c-4.36-1.58-6.93-3.64-6.93-5.96V145.16Zm60.25 120.92c0 1.89-1.69 3.61-4.64 5.03V148.08c1.92-.83 3.5-1.8 4.64-2.92v120.92Zm-.34-127.35v-10.54l11.19.99-11.19 9.55ZM395.99 2.41 595.93 71.9l-37.32 27.87L358.19 31.1l37.8-28.69Zm163.8 124.04v-25.06l37.25-27.82v20.75l-37.25 32.14v-.01ZM192.45 35.7 392.66 2.43l-36.75 27.89h-.04L156.6 62.91l35.85-27.21Zm-38.66 29.7L355.7 32.36l202.08 69.24v11.66l-201.67-69.1-.24-.08-202.08 33.48V65.4Zm401.24 49.03L155.76 79.26 355.7 46.14l199.33 68.3v-.01ZM153.8 81.1l404 35.59v10.86l-404-35.59V81.1Zm17.09 14.38 369.82 32.58v11.8l-369.82-32.23V95.47v.01Zm34.81 17.2 60.25 5.25v.06l-.12-.03c-1.84 6.82-24.91 9.82-42.51 7.49-10.87-1.44-17.62-4.65-17.62-8.37v-4.4Zm6.93 12.48v123.13c-4.36-1.58-6.93-3.64-6.93-5.96V121.41c1.65 1.61 4.17 2.83 6.93 3.75Zm-8.93 127.17c0 7.71 16.22 11.16 32.3 11.16s31.95-3.45 31.95-11.16v-10.97l28.12 2.48v15.72c0 7.71 16.22 11.16 32.3 11.16s31.95-3.45 31.95-11.16V249.5l28.12 2.48v15.12c0 7.71 16.22 11.16 32.3 11.16s31.95-3.45 31.95-11.16v-9.46l28.12 2.48v16.01c0 7.71 16.22 11.16 32.3 11.16s31.95-3.45 31.95-11.16v-10.35l34.36 3.03-37.97 28.83-370.29-32.65 32.55-25.53v12.89l-.01-.02Zm-51.91 38.45-6.89-.6 6.89-5.56v6.16Zm-8.45 1.27 425.04 37.25v11.76l-425.04-37.25v-11.76Zm427.04 47.89v-11.17l38.46-29.14v9.26l-38.46 31.05Z",
    fill: "#3763FF"
  })), _path62 || (_path62 = /*#__PURE__*/react.createElement("path", {
    d: "M105.933 267.726c-4.039 26.24 5.327 46.605 22.444 46.576 18.958-.03 37.482-28.621 39.106-57.012 1.538-27.137-13.046-40.203-28.929-35.074-15.147 4.89-29.871 27.675-32.61 45.51h-.011Z",
    fill: "#82EBCD",
    stroke: "#4EBA9B",
    strokeWidth: 2
  })), _path63 || (_path63 = /*#__PURE__*/react.createElement("path", {
    d: "M112.414 268.757c-3.706 26.121 4.888 46.393 20.596 46.363 17.398-.03 34.398-28.49 35.888-56.752 1.411-27.012-11.972-40.018-26.548-34.913-13.9 4.867-27.413 27.548-29.926 45.302h-.01Z",
    fill: "#fff",
    stroke: "#4EBA9B",
    strokeWidth: 2
  })), _path64 || (_path64 = /*#__PURE__*/react.createElement("path", {
    d: "M157.054 259.082c-2.583-1.189-7.233-.783-13.94 2.072v-6.979l11.864-6.076v-9.517l-31.526 15.891v9.764l11.535-5.908v6.949c-7.799 4.599-12.042 9.139-13.334 11.618v9.804c2.951 1.04 8.009.188 13.334-1.904v16.763l8.127-4.134v-16.693c5.843-3.549 11.824-8.436 13.94-11.856.06-5.64 0-7.752 0-9.794Zm-18.003 19.558c-6.826 3.291-14.854 5.542-16.841 2.855.864-3.013 6.726-8.257 12.777-12.014v6.265l8.127-4.134v-6.265c5.882-2.429 11.138-3.35 13.314-1.219-.874 3.846-11.078 11.489-17.377 14.522v-.01Z",
    fill: "#4EBA9B"
  })), _path65 || (_path65 = /*#__PURE__*/react.createElement("path", {
    d: "m154.978 238.582 1.828.823-1.828.922v-1.745ZM157.054 259.082l1.818.833-1.798.852-.02-1.685ZM157.054 263.424l1.62 1.497v.674l-1.838 2.736.218-4.907ZM134.987 275.746l1.818.823v-1.755l-1.818.932ZM134.987 301.569l1.818.833v-1.765l-1.818.932ZM121.644 286.709l1.828.833v-1.051l-1.828.218ZM123.471 278.452l-1.47 2.488v1.011l1.47 1.467v-4.966ZM123.452 264.237l1.828.833v-1.765l-1.828.932Z",
    fill: "#4EBA9B"
  })), _path66 || (_path66 = /*#__PURE__*/react.createElement("path", {
    d: "M158.873 259.915c-2.584-1.19-7.234-.783-13.94 2.072v-6.979l11.863-6.077v-9.516l-31.526 15.89v9.765l11.535-5.909v6.949c-7.799 4.6-12.042 9.14-13.333 11.618v9.804c2.951 1.041 8.008.189 13.333-1.903v16.763l8.128-4.134v-16.693c5.842-3.549 11.823-8.436 13.94-11.856.059-5.641 0-7.752 0-9.794Zm-18.004 19.558c-6.826 3.291-14.854 5.541-16.841 2.855.864-3.014 6.727-8.257 12.777-12.014v6.265l8.128-4.134v-6.265c5.882-2.429 11.138-3.351 13.314-1.219-.875 3.846-11.079 11.489-17.378 14.522v-.01Z",
    fill: "#96F2D7"
  })), _path67 || (_path67 = /*#__PURE__*/react.createElement("path", {
    d: "M313.864 208.135c-3.741 26.471 4.934 47.015 20.79 46.985 17.561-.03 34.721-28.872 36.225-57.513 1.424-27.375-12.085-40.555-26.797-35.381-14.713 5.173-27.67 27.917-30.208 45.909h-.01Z",
    fill: "#FFDFA0",
    stroke: "#FFBB38",
    strokeWidth: 2
  })), _path68 || (_path68 = /*#__PURE__*/react.createElement("path", {
    d: "M319.882 208.135c-3.741 26.471 4.934 47.015 20.79 46.985 17.56-.03 34.72-28.872 36.225-57.513 1.424-27.375-12.085-40.555-26.798-35.381-14.713 5.173-27.67 27.917-30.207 45.909h-.01Z",
    fill: "#fff",
    stroke: "#FFBB38",
    strokeWidth: 2
  })), _path69 || (_path69 = /*#__PURE__*/react.createElement("path", {
    d: "m369.385 188.425-3.751 1.859c-.682-2.572-1.765-4.862-3.35-6.57-4.733-5.093-9.798-2.843-14.351-.603-3.992 1.969-10.39 5.395-10.39 5.395v15.671l-4.263 2.11v5.917l4.263-2.17v6.028l-4.263 2.109v5.917l4.263-2.17v15.632s8.574-4.169 11.583-5.767c6.84-3.636 11.814-9.352 15.254-19.137.512-1.457.973-3.185 1.344-5.073l3.671-1.869v-5.394l-2.899 1.436c.151-2.14.161-4.32-.02-6.449l2.919-1.487v-5.395l-.01.01Zm-28.162 3.336s3.33-1.638 8.254-4.25c6.489-3.436 10.36-.803 12.145 4.762l-20.389 10.086v-10.598h-.01Zm9.698 33.925c-3.52 2.039-9.698 4.832-9.698 4.832V220.05l20.239-10.307c-2.176 7.142-6.619 13.672-10.541 15.943Zm11.885-24.301c0 .743-.04 1.486-.111 2.24l-21.472 10.618v-6.088l21.382-10.889c.131 1.306.201 2.682.201 4.108v.011Z",
    fill: "#FFBB38"
  })), _path70 || (_path70 = /*#__PURE__*/react.createElement("path", {
    d: "m370.809 189.018-3.751 1.859c-.682-2.572-1.765-4.863-3.35-6.57-4.734-5.094-9.798-2.843-14.352-.603-3.991 1.969-10.39 5.394-10.39 5.394v15.672l-4.262 2.11v5.917l4.262-2.17v6.027l-4.262 2.11v5.917l4.262-2.17v15.631s8.575-4.169 11.584-5.766c6.84-3.637 11.814-9.353 15.254-19.137.512-1.457.973-3.185 1.344-5.073l3.671-1.869v-5.395l-2.899 1.437c.151-2.14.161-4.32-.02-6.45l2.919-1.486v-5.395l-.01.01Zm-28.162 3.335s3.33-1.637 8.254-4.249c6.489-3.436 10.36-.804 12.145 4.762l-20.389 10.086v-10.599h-.01Zm9.698 33.925c-3.52 2.04-9.698 4.832-9.698 4.832v-10.467l20.239-10.308c-2.177 7.143-6.62 13.673-10.541 15.943Zm11.885-24.301c0 .744-.041 1.487-.111 2.24l-21.472 10.619v-6.088l21.382-10.89c.13 1.306.201 2.683.201 4.109v.01Z",
    fill: "#FFDFA0"
  })), _path71 || (_path71 = /*#__PURE__*/react.createElement("path", {
    d: "m369.385 188.425 1.424.593-1.424.703v-1.296ZM369.385 200.31l1.424.602-1.424.704v-1.306ZM337.543 237.55l1.424.592v-1.285l-1.424.693ZM333.28 224.088l1.424.593v-1.316l-1.424.723ZM333.28 212.194l1.424.603v-1.326l-1.424.723Z",
    fill: "#FFBB38"
  })), _path72 || (_path72 = /*#__PURE__*/react.createElement("path", {
    d: "M1.864 298.135c-3.74 26.471 4.934 47.015 20.79 46.985 17.561-.03 34.72-28.872 36.225-57.513 1.424-27.375-12.085-40.555-26.797-35.381-14.713 5.173-27.67 27.917-30.208 45.909h-.01Z",
    fill: "#FFDFA0",
    stroke: "#FFBB38",
    strokeWidth: 2
  })), _path73 || (_path73 = /*#__PURE__*/react.createElement("path", {
    d: "M7.882 298.135c-3.741 26.471 4.934 47.015 20.79 46.985 17.56-.03 34.72-28.872 36.225-57.513 1.424-27.375-12.085-40.555-26.798-35.381-14.713 5.173-27.67 27.917-30.207 45.909h-.01Z",
    fill: "#fff",
    stroke: "#FFBB38",
    strokeWidth: 2
  })), _path74 || (_path74 = /*#__PURE__*/react.createElement("path", {
    d: "m57.385 278.425-3.751 1.859c-.682-2.572-1.765-4.862-3.35-6.57-4.733-5.093-9.798-2.843-14.351-.603-3.992 1.969-10.39 5.395-10.39 5.395v15.671l-4.263 2.11v5.917l4.263-2.17v6.028l-4.263 2.109v5.917l4.263-2.17v15.632s8.575-4.169 11.583-5.767c6.84-3.636 11.814-9.352 15.254-19.137.512-1.457.973-3.185 1.344-5.073l3.67-1.869v-5.394l-2.898 1.436c.15-2.14.16-4.32-.02-6.449l2.919-1.487v-5.395l-.01.01Zm-28.162 3.336s3.33-1.638 8.254-4.25c6.489-3.436 10.36-.803 12.145 4.762l-20.389 10.086v-10.598h-.01Zm9.698 33.925c-3.52 2.039-9.698 4.832-9.698 4.832V310.05l20.239-10.307c-2.176 7.142-6.62 13.672-10.54 15.943Zm11.885-24.301c0 .743-.04 1.486-.11 2.24l-21.473 10.618v-6.088l21.382-10.889c.13 1.306.2 2.682.2 4.108v.011Z",
    fill: "#FFBB38"
  })), _path75 || (_path75 = /*#__PURE__*/react.createElement("path", {
    d: "m58.809 279.018-3.751 1.859c-.682-2.572-1.765-4.863-3.35-6.57-4.734-5.094-9.798-2.843-14.352-.603-3.991 1.969-10.39 5.394-10.39 5.394v15.672l-4.262 2.11v5.917l4.262-2.17v6.027l-4.262 2.11v5.917l4.262-2.17v15.631s8.575-4.169 11.584-5.766c6.84-3.637 11.814-9.353 15.254-19.137.511-1.457.973-3.185 1.344-5.073l3.67-1.869v-5.395l-2.898 1.437c.15-2.14.16-4.32-.02-6.45l2.919-1.486v-5.395l-.01.01Zm-28.162 3.335s3.33-1.637 8.254-4.249c6.489-3.436 10.36-.804 12.145 4.762l-20.389 10.086v-10.599h-.01Zm9.698 33.925c-3.52 2.04-9.698 4.832-9.698 4.832v-10.467l20.239-10.308c-2.177 7.143-6.62 13.673-10.54 15.943Zm11.885-24.301c0 .744-.04 1.487-.11 2.24l-21.473 10.619v-6.088l21.382-10.89c.13 1.306.2 2.683.2 4.109v.01Z",
    fill: "#FFDFA0"
  })), _path76 || (_path76 = /*#__PURE__*/react.createElement("path", {
    d: "m57.385 278.425 1.424.593-1.424.703v-1.296ZM57.385 290.31l1.424.602-1.424.704v-1.306ZM25.543 327.55l1.424.592v-1.285l-1.424.693ZM21.28 314.088l1.424.593v-1.316l-1.424.723ZM21.28 302.194l1.424.603v-1.326l-1.424.723Z",
    fill: "#FFBB38"
  })), _path77 || (_path77 = /*#__PURE__*/react.createElement("path", {
    d: "M209.864 238.135c-3.741 26.471 4.934 47.015 20.79 46.985 17.561-.03 34.721-28.872 36.225-57.513 1.424-27.375-12.085-40.555-26.797-35.381-14.713 5.173-27.67 27.917-30.208 45.909h-.01Z",
    fill: "#A3D8FF",
    stroke: "#34AAFF",
    strokeWidth: 2
  })), _path78 || (_path78 = /*#__PURE__*/react.createElement("path", {
    d: "M215.882 238.135c-3.741 26.471 4.934 47.015 20.79 46.985 17.561-.03 34.72-28.872 36.225-57.513 1.424-27.375-12.085-40.555-26.798-35.381-14.713 5.173-27.67 27.917-30.207 45.909h-.01Z",
    fill: "#fff",
    stroke: "#34AAFF",
    strokeWidth: 2
  })), _path79 || (_path79 = /*#__PURE__*/react.createElement("path", {
    d: "M249.98 206.682v2.752c0 1.135.15 1.407 1.915 1.708 4.333.754 7.512 6.018 8.615 10.85 1.174 5.113.923 12.899-.662 19.117-1.745 6.861-4.302 11.563-5.686 13.482-1.153 1.597-2.497 3.576-3.5 4.761-.532.633-.682 1.176-.682 2.281v2.25c0 .884.491 1.135 1.283.331 2.397-2.451 4.855-6.107 6.369-8.84 1.915-3.446 4.754-10.156 5.977-16.475 1.063-5.495 1.495-12.286.421-17.801-1.073-5.516-2.216-10.488-5.867-13.12-2.336-1.688-3.309-2.2-5.385-2.753-1.494-.392-2.808.02-2.808 1.467l.01-.01ZM238.497 212.026c1.434-1.527 1.755-1.447 1.755.08v2.432c0 .984-.401 1.486-1.374 2.632-1.304 1.527-2.718 3.475-4.543 6.891-1.826 3.416-3.801 8.238-4.814 15.31-1.013 7.072-.452 13.15 1.434 17.62 1.885 4.461 4.122 6.349 6.308 7.133 1.615.583 2.989.181 2.989 2.039v2.1c0 .804.07 2.3-2.186 1.919-2.458-.422-5.717-1.708-7.653-4.641-2.296-3.466-3.791-7.635-4.392-12.196-.662-4.973-.632-9.855.631-16.154 1.254-6.289 3.591-12.467 5.537-16.204 1.945-3.747 4.914-7.454 6.318-8.951l-.01-.01Z",
    fill: "#34AAFF"
  })), _path80 || (_path80 = /*#__PURE__*/react.createElement("path", {
    d: "M243.391 219.601c0-1.678.632-2.04.953-2.19.321-.151.922-.482 1.344-.693.421-.211 1.073-.181 1.073.984v4.049c.892-.332 2.216-.483 3.199.572.983 1.055 1.284 2.13 1.585 3.325.3 1.196-.211 2.16-.843 2.492-.632.331-1.193.663-1.554.783-.361.121-.692.061-.923-.844-.231-.904-.782-2.22-2.307-1.918-1.895.371-3.289 2.16-3.741 3.114-.451.954-.922 3.205-.451 4.671.401 1.236 1.645 1.366 3.139.945 2.066-.583 3.891-.945 4.874-.523.983.422 2.508 1.407 2.518 5.455.01 4.049-.923 6.801-2.036 8.509-1.114 1.708-2.307 3.114-3.33 3.717v3.687c0 .753-.261 1.949-1.003 2.371-.742.422-1.103.542-1.524.693-.422.15-.893-.091-.893-1.045v-3.988c-.983.211-2.126.361-3.019-.03-.892-.392-1.945-1.859-2.126-2.492-.18-.633-.511-2.401-.571-3.144-.061-.743.3-1.226.842-1.497.542-.271.983-.512 1.374-.693.391-.181.983-.633 1.224.814.24 1.446.812 2.752 2.366 2.571 1.555-.18 3.35-1.436 4.333-3.204.983-1.768 1.073-4.24.722-5.505-.351-1.266-1.765-1.296-3.6-.935-1.836.362-3.25 1.135-5.095.091-2.006-1.135-2.036-4.732-1.795-6.771.24-2.04 1.313-5.666 2.808-7.344 1.494-1.677 2.126-2.16 2.457-2.431v-3.596Z",
    fill: "#34AAFF"
  })), _path81 || (_path81 = /*#__PURE__*/react.createElement("path", {
    d: "M248.476 228.662c.411.864 1.524 1.045 2.096.784.572-.262-.602-1.437-.602-1.437l-1.504.653h.01ZM251.905 235.302c-1.654-1.034-2.778-1.245-3.831-1.085-1.053.161 1.535 1.809 1.535 1.809l2.306-.714-.01-.01ZM243.822 258.709c.712.472 1.505.774 1.966.603.461-.171 0-1.477 0-1.477l-1.966.874ZM250.131 264.526c.732.884 1.444.814 1.885.703.442-.11-.16-1.688-.16-1.688l-1.725.985ZM240.553 245.7c.612-.191 1.634.392 1.805.753.17.362-.532.925-.532.925l-1.153-.422-.12-1.246v-.01ZM246.119 216.627c.662-.03 1.364.251 1.795.693.432.442-1.223.924-1.223.924l-.562-1.617h-.01ZM248.476 221.54c.31.08 1.454.271 2.366.874.913.602-1.534.773-1.534.773l-.832-1.647ZM239.941 210.921c.733-.01 1.324.402 1.525.603.2.201-1.204 1.607-1.204 1.607l-.21-.924-.111-1.286ZM239.209 264.606c.883.251 1.916.643 2.106.924.191.282-1.163.242-1.163.242l-.682-.583-.261-.583Z",
    fill: "#34AAFF"
  })), _path82 || (_path82 = /*#__PURE__*/react.createElement("path", {
    d: "M251.384 207.214v2.753c0 1.135.151 1.406 1.916 1.708 4.332.753 7.511 6.017 8.615 10.849 1.173 5.113.922 12.899-.662 19.117-1.745 6.862-4.303 11.563-5.687 13.482-1.153 1.597-2.497 3.576-3.5 4.762-.532.633-.682 1.175-.682 2.28v2.25c0 .884.492 1.136 1.284.332 2.397-2.451 4.854-6.108 6.368-8.84 1.916-3.446 4.754-10.157 5.978-16.476 1.063-5.495 1.494-12.286.421-17.801-1.073-5.515-2.217-10.488-5.867-13.12-2.337-1.688-3.31-2.2-5.386-2.753-1.494-.391-2.808.021-2.808 1.467l.01-.01ZM239.901 212.559c1.434-1.527 1.755-1.447 1.755.08v2.431c0 .985-.401 1.487-1.374 2.632-1.304 1.527-2.718 3.476-4.543 6.892-1.825 3.415-3.801 8.237-4.814 15.309-1.013 7.073-.451 13.151 1.434 17.621 1.886 4.47 4.122 6.349 6.308 7.133 1.615.582 2.989.18 2.989 2.039v2.099c0 .804.07 2.301-2.186 1.919-2.457-.422-5.717-1.708-7.652-4.641-2.297-3.466-3.791-7.635-4.393-12.196-.662-4.972-.632-9.855.632-16.153 1.253-6.289 3.59-12.467 5.536-16.205 1.945-3.747 4.914-7.454 6.318-8.95l-.01-.01Z",
    fill: "#A3D8FF"
  })), _path83 || (_path83 = /*#__PURE__*/react.createElement("path", {
    d: "M244.805 220.123c0-1.678.632-2.039.953-2.19.321-.151.922-.482 1.344-.693.421-.211 1.073-.181 1.073.984v4.049c.892-.332 2.216-.482 3.199.573.983 1.054 1.284 2.129 1.585 3.325.3 1.195-.211 2.16-.843 2.491-.632.332-1.193.663-1.554.784-.361.12-.692.06-.923-.844-.231-.904-.782-2.22-2.307-1.919-1.895.372-3.289 2.16-3.741 3.114-.451.955-.922 3.205-.451 4.672.401 1.235 1.645 1.366 3.139.944 2.066-.583 3.892-.944 4.874-.522.983.421 2.508 1.406 2.518 5.454.01 4.049-.923 6.802-2.036 8.509-1.113 1.708-2.307 3.115-3.33 3.717v3.687c0 .754-.261 1.949-1.003 2.371-.742.422-1.103.542-1.524.693-.421.151-.893-.09-.893-1.045v-3.988c-.983.211-2.126.362-3.019-.03-.892-.392-1.945-1.858-2.126-2.491-.18-.633-.511-2.401-.571-3.145-.061-.743.301-1.225.842-1.497.542-.271.983-.512 1.374-.693.391-.181.983-.633 1.224.814.24 1.447.812 2.753 2.366 2.572 1.555-.181 3.35-1.437 4.333-3.205.983-1.768 1.073-4.239.722-5.505s-1.765-1.296-3.6-.934c-1.836.361-3.25 1.135-5.095.09-2.006-1.135-2.036-4.732-1.795-6.771.24-2.039 1.314-5.666 2.808-7.343 1.494-1.678 2.126-2.16 2.457-2.431v-3.597Z",
    fill: "#A3D8FF"
  })), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "hero_svg__a",
    x1: 610,
    y1: 2.12,
    x2: 142.999,
    y2: 304.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#CDEEFF"
  })))));
};
/* harmony default export */ var hero = (SvgHero);
;// CONCATENATED MODULE: ./components/containers/home/Hero.tsx



function Hero() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "10x"
                            }),
                            " your ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "DeFi yield,"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "safely and securely"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: "Archimedes selects battle tested yield-bearing stablecoins and leverages them up to 10x, producing a sustainable 'Top of Market' APY"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroLink, {
                        size: "lg",
                        variant: "button",
                        href: "/open-position",
                        children: "Open 10x Position"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroLink, {
                        size: "lg",
                        variant: "outline",
                        href: "/earn",
                        children: "Earn Passive APY"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroLink, {
                        variant: "thick",
                        href: "https://docs.archimedesfi.com/",
                        target: "_blank",
                        children: "User Docs"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroImageWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hero, {})
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/store/getters.ts
var getters = __webpack_require__(4478);
// EXTERNAL MODULE: ./node_modules/react-countup/build/index.js
var build = __webpack_require__(7857);
;// CONCATENATED MODULE: ./components/containers/home/HomeCards/HomeCards.styles.ts

function HomeCards_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  z-index: 1;\n  margin: auto;\n  width: fit-content;\n  display: grid;\n  grid-template-columns: min-content min-content min-content;\n  column-gap: 160px;\n  padding-bottom: 16px;\n  @media (max-width: ",
        ") {\n    column-gap: 64px;\n    padding-bottom: 0;\n  }\n  @media (max-width: ",
        ") {\n    display: flex;\n    flex-direction: column;\n  }\n"
    ]);
    HomeCards_styles_templateObject = function() {
        return data;
    };
    return data;
}
function HomeCards_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  white-space: nowrap;\n  justify-content: center;\n  @media (max-width: ",
        ") {\n    padding: 32px 0;\n  }\n"
    ]);
    HomeCards_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function HomeCards_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 36px;\n  line-height: 47px;\n  font-weight: 700;\n  padding-bottom: 18px;\n  color: ",
        ";\n  font-family: ",
        ";\n  @media (max-width: ",
        ") {\n    font-size: 32px;\n    padding-bottom: 4px;\n  }\n  @media (max-width: ",
        ") {\n    padding-bottom: 0;\n  }\n"
    ]);
    HomeCards_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function HomeCards_styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (max-width: ",
        ") {\n    font-size: 14px;\n  }\n"
    ]);
    HomeCards_styles_templateObject3 = function() {
        return data;
    };
    return data;
}

const CardsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45223f0b-0"
})(HomeCards_styles_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.md;
});
const StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45223f0b-1"
})(HomeCards_styles_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.md;
});
const Value = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45223f0b-2"
})(HomeCards_styles_templateObject2(), (param)=>{
    let { theme: { colors: { primary: { main  }  }  }  } = param;
    return main;
}, (param)=>{
    let { theme: { fonts: { spaceGrotesk  }  }  } = param;
    return spaceGrotesk;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.md;
});
const Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-45223f0b-3"
})(HomeCards_styles_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
});

// EXTERNAL MODULE: ./components/eth/Utils.ts
var Utils = __webpack_require__(1322);
;// CONCATENATED MODULE: ./components/containers/home/HomeCards/index.tsx





function HomeCards() {
    const formatNumberWithCommas = (value)=>{
        return (0,Utils/* formatLongNumber */.mu)(value);
    // return value.toLocaleString();
    };
    const tvl = (0,getters/* useTvl */.jT)();
    const lpApy = (0,getters/* useLpAPY */.T7)();
    const ltApy = (0,getters/* useFinalOusdApy */.gW)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardsWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCard, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Value, {
                        children: [
                            !tvl && "--",
                            tvl && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    "$",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
                                        useEasing: true,
                                        duration: 3,
                                        end: tvl,
                                        formattingFn: formatNumberWithCommas
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                        children: "Total Value Locked"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCard, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Value, {
                        children: [
                            !ltApy && "--",
                            ltApy && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
                                        useEasing: true,
                                        duration: 3,
                                        end: ltApy,
                                        formattingFn: formatNumberWithCommas,
                                        decimals: 2
                                    }),
                                    "%"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                        children: "Leverage Taker APY"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCard, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Value, {
                        children: [
                            !lpApy && "--",
                            lpApy && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
                                        useEasing: true,
                                        duration: 3,
                                        end: lpApy,
                                        formattingFn: formatNumberWithCommas,
                                        decimals: 2
                                    }),
                                    "%"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                        children: "Liquidity Provider APY"
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/common/Card/index.tsx + 1 modules
var Card = __webpack_require__(2490);
;// CONCATENATED MODULE: ./components/containers/home/FeaturesList.styles.ts

function FeaturesList_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 105px 0;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 24px;\n  position: relative;\n  @media (max-width: ",
        ") {\n    padding: 80px 0 60px 0;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0 28px;\n  }\n  @media (max-width: ",
        ") {\n    grid-template-columns: 1fr;\n  }\n"
    ]);
    FeaturesList_styles_templateObject = function() {
        return data;
    };
    return data;
}
function FeaturesList_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 48px 32px 0;\n  height: 377px;\n  img {\n    margin-bottom: 40px;\n  }\n  h4 {\n    padding-bottom: 1.6rem;\n  }\n  p {\n    color: ",
        ";\n  }\n  @media (max-width: ",
        ") {\n    padding: 32px;\n    height: 337px;\n  }\n"
    ]);
    FeaturesList_styles_templateObject1 = function() {
        return data;
    };
    return data;
}


const FeaturesList_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-78d64ce-0"
})(FeaturesList_styles_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.md;
});
const Feature = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-78d64ce-1"
})(FeaturesList_styles_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.colors.functional.darkGray;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
});

;// CONCATENATED MODULE: ./components/containers/home/FeaturesList.tsx




function FeaturesList() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FeaturesList_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/home/tokenized.svg",
                        alt: "",
                        width: 40,
                        height: 40
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: "Tokenized Positions"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Positions are tradable as an NFT without unwinding your leverage"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            variant: "thick",
                            href: "https://opensea.io/collection/archimedespositiontoken-v2",
                            target: "_blank",
                            children: "OpenSea"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/home/opensource.svg",
                        alt: "",
                        width: 40,
                        height: 40
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: "Open Source & Audited"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "As a fully doxxed team, we are open and transparent with our community"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            variant: "thick",
                            href: "https://github.com/thisisarchimedes/Archimedes_Finance",
                            target: "_blank",
                            children: "GitHub"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/home/tokenomics.svg",
                        alt: "",
                        width: 40,
                        height: 40
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: "Superior Tokenomics"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Yield-bearing stablecoin strategies as base assets, actively managed to keep APY high"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            variant: "thick",
                            href: "https://docs.archimedesfi.com/",
                            target: "_blank",
                            children: "User Docs"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/home/stability.svg",
                        alt: "",
                        width: 40,
                        height: 40
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: "True Stability"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Positions are over collateralized with battle tested stablecoins. Yield-bearing stablecoin strategies keep APY high"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            variant: "thick",
                            href: "https://docs.archimedesfi.com/archimedes-finance-whitepaper-(v2)",
                            target: "_blank",
                            children: "Whitepaper"
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/common/Container/index.tsx + 1 modules
var Container = __webpack_require__(7987);
// EXTERNAL MODULE: ./components/common/Typography/index.tsx + 1 modules
var Typography = __webpack_require__(990);
;// CONCATENATED MODULE: ./components/containers/home/LeverageLiquidity.styles.ts

function LeverageLiquidity_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 16px;\n"
    ]);
    LeverageLiquidity_styles_templateObject = function() {
        return data;
    };
    return data;
}
function LeverageLiquidity_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 120px 104px;\n  display: flex;\n  justify-content: space-between;\n  & > div {\n    width: 410px;\n    max-width: 95%;\n  }\n  @media (max-width: ",
        ") {\n    flex-direction: column;\n    padding: 80px 0;\n    img {\n      width: 60% !important;\n      margin-top: 40px;\n    }\n    & > div {\n      width: 100%;\n    }\n  }\n  @media (max-width: ",
        ") {\n    img {\n    width: 100% !important;\n  }\n\n"
    ]);
    LeverageLiquidity_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function LeverageLiquidity_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: url('/home/leverage-background.svg') center center no-repeat;\n  background-size: cover;\n  img {\n    width: 478px;\n    aspect-ratio: 1.5;\n  }\n"
    ]);
    LeverageLiquidity_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function LeverageLiquidity_styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: url('/home/liquidity-background.svg') center center no-repeat;\n  background-size: cover;\n  img {\n    width: 453px;\n    aspect-ratio: 1.4;\n  }\n  @media (max-width: ",
        ") {\n    ",
        " {\n      flex-direction: column-reverse;\n    }\n  }\n"
    ]);
    LeverageLiquidity_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 16px;\n  font-size: 14px;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 30px 0 6px;\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}



const Title = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Typography */.Z).withConfig({
    componentId: "sc-d4fb2c21-0"
})(LeverageLiquidity_styles_templateObject());
const LeverageLiquidity_styles_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    componentId: "sc-d4fb2c21-1"
})(LeverageLiquidity_styles_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.md;
});
const LeverageBackground = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d4fb2c21-2"
})(LeverageLiquidity_styles_templateObject2());
const LiquidityBackground = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d4fb2c21-3"
})(LeverageLiquidity_styles_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
}, LeverageLiquidity_styles_Wrapper);
const LeverageLiquidity_styles_Label = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-d4fb2c21-4"
})(_templateObject4());
const APY = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Typography */.Z).withConfig({
    componentId: "sc-d4fb2c21-5"
})(_templateObject5(), (param)=>{
    let { theme  } = param;
    return theme.colors.primary.main;
});

;// CONCATENATED MODULE: ./components/containers/home/Leverage.tsx






const formatNumberWithCommas = (value)=>{
    return value.toLocaleString();
};
function Leverage() {
    const ltApy = (0,getters/* useFinalOusdApy */.gW)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LeverageBackground, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeverageLiquidity_styles_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            type: "h1",
                            children: "Taking Leverage"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Buy ARCH Tokens on Uniswap, then Open a Position by depositing collateral and paying with ARCH tokens for access to leverage."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Get your Tradeable Position wrapped as an NFT, and enjoy high yields at reduced risks."
                        }),
                        !!ltApy && /*#__PURE__*/ (0,jsx_runtime.jsxs)(APY, {
                            type: "h1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
                                    useEasing: true,
                                    duration: 3,
                                    end: ltApy,
                                    formattingFn: formatNumberWithCommas,
                                    decimals: 2
                                }),
                                "%"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LeverageLiquidity_styles_Label, {
                            children: "Current Estimated Net APY"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: "/open-position",
                                variant: "outline",
                                children: "Open a Position"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                target: "_blank",
                                href: "https://docs.archimedesfi.com/",
                                variant: "thick",
                                children: "User Docs"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/home/leverage.svg",
                    alt: "",
                    width: 478,
                    height: 321
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/containers/home/Liquidity.tsx






const Liquidity_formatNumberWithCommas = (value)=>{
    return value.toLocaleString();
};
function Liquidity() {
    const lpApy = (0,getters/* useLpAPY */.T7)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LiquidityBackground, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeverageLiquidity_styles_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/home/liquidity.svg",
                    alt: "",
                    width: 453,
                    height: 324
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            type: "h1",
                            children: "Earn - Providing Liquidity"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Provide liquidity to our 3CRV/lvUSD Curve Pool and enjoy a sustainable 'Top of the Market' APY with lower risk."
                        }),
                        !!lpApy && /*#__PURE__*/ (0,jsx_runtime.jsxs)(APY, {
                            type: "h1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
                                    useEasing: true,
                                    duration: 3,
                                    end: lpApy,
                                    formattingFn: Liquidity_formatNumberWithCommas,
                                    decimals: 2
                                }),
                                "%"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LeverageLiquidity_styles_Label, {
                            children: "Current Curve Pool APY"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: "/earn",
                                variant: "outline",
                                children: "Provide Liquidity"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                target: "_blank",
                                href: "https://docs.archimedesfi.com/",
                                variant: "thick",
                                children: "User Docs"
                            })
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./pages/home.styles.ts

function home_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: url('/home/background-gradient.svg') center center no-repeat;\n  background-size: cover;\n"
    ]);
    home_styles_templateObject = function() {
        return data;
    };
    return data;
}

const GradientWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c28540de-0"
})(home_styles_templateObject());

;// CONCATENATED MODULE: ./pages/index.page.tsx









function Home() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "ArchimedesFi"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Up to 10X leverage on leading meta-vaults, tokenized as NFTs"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.ico"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeCards, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturesList, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Leverage, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Liquidity, {})
        ]
    });
}


/***/ }),

/***/ 7857:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var React = __webpack_require__(7294);
var countup_js = __webpack_require__(8273);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/**
 * Silence SSR Warnings.
 * Borrowed from Formik v2.1.1, Licensed MIT.
 *
 * https://github.com/formium/formik/blob/9316a864478f8fcd4fa99a0735b1d37afdf507dc/LICENSE
 */
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? React.useLayoutEffect : React.useEffect;

/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Create a stable reference to a callback which is updated after each render is committed.
 * Typed version borrowed from Formik v2.2.1. Licensed MIT.
 *
 * https://github.com/formium/formik/blob/9316a864478f8fcd4fa99a0735b1d37afdf507dc/LICENSE
 */
function useEventCallback(fn) {
  var ref = React.useRef(fn);

  // we copy a ref to the callback scoped to the current state/props on each render
  useIsomorphicLayoutEffect(function () {
    ref.current = fn;
  });
  return React.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current.apply(void 0, args);
  }, []);
}

var createCountUpInstance = function createCountUpInstance(el, props) {
  var decimal = props.decimal,
    decimals = props.decimals,
    duration = props.duration,
    easingFn = props.easingFn,
    end = props.end,
    formattingFn = props.formattingFn,
    numerals = props.numerals,
    prefix = props.prefix,
    separator = props.separator,
    start = props.start,
    suffix = props.suffix,
    useEasing = props.useEasing,
    enableScrollSpy = props.enableScrollSpy,
    scrollSpyDelay = props.scrollSpyDelay,
    scrollSpyOnce = props.scrollSpyOnce;
  return new countup_js.CountUp(el, end, {
    startVal: start,
    duration: duration,
    decimal: decimal,
    decimalPlaces: decimals,
    easingFn: easingFn,
    formattingFn: formattingFn,
    numerals: numerals,
    separator: separator,
    prefix: prefix,
    suffix: suffix,
    useEasing: useEasing,
    useGrouping: !!separator,
    enableScrollSpy: enableScrollSpy,
    scrollSpyDelay: scrollSpyDelay,
    scrollSpyOnce: scrollSpyOnce
  });
};

var _excluded$1 = ["ref", "startOnMount", "enableReinitialize", "delay", "onEnd", "onStart", "onPauseResume", "onReset", "onUpdate"];
var DEFAULTS = {
  decimal: '.',
  delay: null,
  prefix: '',
  suffix: '',
  duration: 2,
  start: 0,
  startOnMount: true,
  enableReinitialize: true
};
var useCountUp = function useCountUp(props) {
  var _useMemo = React.useMemo(function () {
      return _objectSpread2(_objectSpread2({}, DEFAULTS), props);
    }, [props]),
    ref = _useMemo.ref,
    startOnMount = _useMemo.startOnMount,
    enableReinitialize = _useMemo.enableReinitialize,
    delay = _useMemo.delay,
    onEnd = _useMemo.onEnd,
    onStart = _useMemo.onStart,
    onPauseResume = _useMemo.onPauseResume,
    onReset = _useMemo.onReset,
    onUpdate = _useMemo.onUpdate,
    instanceProps = _objectWithoutProperties(_useMemo, _excluded$1);
  var countUpRef = React.useRef();
  var timerRef = React.useRef();
  var isInitializedRef = React.useRef(false);
  var createInstance = useEventCallback(function () {
    return createCountUpInstance(typeof ref === 'string' ? ref : ref.current, instanceProps);
  });
  var getCountUp = useEventCallback(function (recreate) {
    var countUp = countUpRef.current;
    if (countUp && !recreate) {
      return countUp;
    }
    var newCountUp = createInstance();
    countUpRef.current = newCountUp;
    return newCountUp;
  });
  var start = useEventCallback(function () {
    var run = function run() {
      return getCountUp(true).start(function () {
        onEnd === null || onEnd === void 0 ? void 0 : onEnd({
          pauseResume: pauseResume,
          reset: reset,
          start: restart,
          update: update
        });
      });
    };
    if (delay && delay > 0) {
      timerRef.current = setTimeout(run, delay * 1000);
    } else {
      run();
    }
    onStart === null || onStart === void 0 ? void 0 : onStart({
      pauseResume: pauseResume,
      reset: reset,
      update: update
    });
  });
  var pauseResume = useEventCallback(function () {
    getCountUp().pauseResume();
    onPauseResume === null || onPauseResume === void 0 ? void 0 : onPauseResume({
      reset: reset,
      start: restart,
      update: update
    });
  });
  var reset = useEventCallback(function () {
    // Quick fix for https://github.com/glennreyes/react-countup/issues/736 - should be investigated
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (getCountUp().el) {
      timerRef.current && clearTimeout(timerRef.current);
      getCountUp().reset();
      onReset === null || onReset === void 0 ? void 0 : onReset({
        pauseResume: pauseResume,
        start: restart,
        update: update
      });
    }
  });
  var update = useEventCallback(function (newEnd) {
    getCountUp().update(newEnd);
    onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate({
      pauseResume: pauseResume,
      reset: reset,
      start: restart
    });
  });
  var restart = useEventCallback(function () {
    reset();
    start();
  });
  var maybeInitialize = useEventCallback(function (shouldReset) {
    if (startOnMount) {
      if (shouldReset) {
        reset();
      }
      start();
    }
  });
  React.useEffect(function () {
    if (!isInitializedRef.current) {
      isInitializedRef.current = true;
      maybeInitialize();
    } else if (enableReinitialize) {
      maybeInitialize(true);
    }
  }, [enableReinitialize, isInitializedRef, maybeInitialize, delay, props.start, props.suffix, props.prefix, props.duration, props.separator, props.decimals, props.decimal, props.formattingFn]);
  React.useEffect(function () {
    return function () {
      reset();
    };
  }, [reset]);
  return {
    start: restart,
    pauseResume: pauseResume,
    reset: reset,
    update: update,
    getCountUp: getCountUp
  };
};

var _excluded = ["className", "redraw", "containerProps", "children", "style"];
var CountUp = function CountUp(props) {
  var className = props.className,
    redraw = props.redraw,
    containerProps = props.containerProps,
    children = props.children,
    style = props.style,
    useCountUpProps = _objectWithoutProperties(props, _excluded);
  var containerRef = React.useRef(null);
  var isInitializedRef = React.useRef(false);
  var _useCountUp = useCountUp(_objectSpread2(_objectSpread2({}, useCountUpProps), {}, {
      ref: containerRef,
      startOnMount: typeof children !== 'function' || props.delay === 0,
      // component manually restarts
      enableReinitialize: false
    })),
    start = _useCountUp.start,
    reset = _useCountUp.reset,
    updateCountUp = _useCountUp.update,
    pauseResume = _useCountUp.pauseResume,
    getCountUp = _useCountUp.getCountUp;
  var restart = useEventCallback(function () {
    start();
  });
  var update = useEventCallback(function (end) {
    if (!props.preserveValue) {
      reset();
    }
    updateCountUp(end);
  });
  var initializeOnMount = useEventCallback(function () {
    if (typeof props.children === 'function') {
      // Warn when user didn't use containerRef at all
      if (!(containerRef.current instanceof Element)) {
        console.error("Couldn't find attached element to hook the CountUp instance into! Try to attach \"containerRef\" from the render prop to a an Element, eg. <span ref={containerRef} />.");
        return;
      }
    }

    // unlike the hook, the CountUp component initializes on mount
    getCountUp();
  });
  React.useEffect(function () {
    initializeOnMount();
  }, [initializeOnMount]);
  React.useEffect(function () {
    if (isInitializedRef.current) {
      update(props.end);
    }
  }, [props.end, update]);
  var redrawDependencies = redraw && props;

  // if props.redraw, call this effect on every props change
  React.useEffect(function () {
    if (redraw && isInitializedRef.current) {
      restart();
    }
  }, [restart, redraw, redrawDependencies]);

  // if not props.redraw, call this effect only when certain props are changed
  React.useEffect(function () {
    if (!redraw && isInitializedRef.current) {
      restart();
    }
  }, [restart, redraw, props.start, props.suffix, props.prefix, props.duration, props.separator, props.decimals, props.decimal, props.className, props.formattingFn]);
  React.useEffect(function () {
    isInitializedRef.current = true;
  }, []);
  if (typeof children === 'function') {
    // TypeScript forces functional components to return JSX.Element | null.
    return children({
      countUpRef: containerRef,
      start: start,
      reset: reset,
      update: updateCountUp,
      pauseResume: pauseResume,
      getCountUp: getCountUp
    });
  }
  return /*#__PURE__*/React.createElement("span", _extends({
    className: className,
    ref: containerRef,
    style: style
  }, containerProps), typeof props.start !== 'undefined' ? getCountUp().formattingFn(props.start) : '');
};

exports.ZP = CountUp;
__webpack_unused_export__ = useCountUp;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,774,888,179], function() { return __webpack_exec__(9208); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);